import React from 'react';

interface BulldozerProps {
  height?: number;
  width?: number;
}

const Bulldozer: React.FC<BulldozerProps> = ({
  height = 71.973,
  width = 134.719,
}) => {
  return (
    <svg
      viewBox="0 0 134.719 71.973"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#808080"
      height={height}
      width={width}
    >
      <defs>
        <filter
          id="Path_21043"
          x="0"
          y="31.5"
          width="104.223"
          height="40.473"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feFlood />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g
        id="Group_51330"
        data-name="Group 51330"
        transform="translate(9)"
        opacity="0.8"
      >
        <path
          id="Path_21023"
          data-name="Path 21023"
          d="M95.173,28.638h-1.1v1.206h-.55V28.638h-1.1v1.206h-.551V28.638H90.833V24.765h1.8a22.4,22.4,0,0,0-.074-2.918c-.163-1.176-1.766-1.52-1.766-1.52.032-.346.057-.7.057-.99a3.835,3.835,0,0,0-.326-1.219,20.294,20.294,0,0,1,3.089,1.747c.555.515.326.355.8,1.21v3.69h.825v5.08h-.07Z"
          transform="translate(-20.342 -7.948)"
          fill="#5f6061"
        />
        <path
          id="Path_21024"
          data-name="Path 21024"
          d="M87.452,39.443V36.859H88.6v1.206h.551V36.859h1.1v1.206h.55V36.859h1.1v1.206h.551V36.859h1.1v1.206H94.1V36.859h1.1v1.206h.551V36.859h1.1v1.206H97.4V36.859h1.1v1.206h.551V36.859h1.1v1.206h.549V36.859h1.1v1.206h.551V36.859h1.1v1.206H104V36.859h1.1v1.206h.551V36.859H106.9v2.583Z"
          transform="translate(-30.274 -16.17)"
          fill="#db9e00"
        />
        <path
          id="Path_21025"
          data-name="Path 21025"
          d="M183.6,29.615l.237-1.689S194.3,10.6,194.792,10.084c.369-.391,1.808-.24,2.488-.143L185.7,29.816Z"
          transform="translate(-174.624 -4.313)"
          fill="#f2f2f2"
        />
        <path
          id="Path_21026"
          data-name="Path 21026"
          d="M107.525,49.372a2.776,2.776,0,0,1-.118.775c-.124.34-.26.52-.541.523H83.017c-.283,0-.42-.184-.545-.523a2.776,2.776,0,0,1-.118-.775h0V41.461H107.44l.086.152v7.741c0-.026,0-.006,0,.018"
          transform="translate(-28.037 -18.187)"
          fill="#ffb800"
        />
        <path
          id="Path_21027"
          data-name="Path 21027"
          d="M174.789,64.108l.012,1.9c-.37.138-.627.356-.653.671l-.015.182q-1.4-.067-2.816-.106l0-.14c-.013-1.338-4.372-1.325-4.358.046V66.7q-1.427,0-2.852.024l-.006-.147c-.039-1.337-4.4-1.238-4.356.132l0,.139q-1.589.061-3.158.145l0-.06c-.07-1.336-4.425-1.141-4.353.228l0,.1q-1.4.1-2.771.211c-.117-1.319-4.434-1.071-4.347.293l.006.091c-.422.04-.839.081-1.253.122a2.976,2.976,0,0,0-1.522-.185c-.511-1.1-4.427-.6-4.27.7l.012.106c-2.154.245-4.152.487-5.938.7a3.1,3.1,0,0,0-1.034.3,8.709,8.709,0,0,0-1.989.724l-.01.013c-.107.021-.211.047-.315.072l-.619-1.517,0-.008.387-.142,12.035-4.416Z"
          transform="translate(-121.039 -28.122)"
          fill="#c28c00"
        />
        <path
          id="Path_21028"
          data-name="Path 21028"
          d="M70.549,43.318l.662.044.987.987-1.274-.086Z"
          transform="translate(13.918 -19.002)"
          fill="#db9e00"
        />
        <path
          id="Path_21029"
          data-name="Path 21029"
          d="M106,43.144l.024.3-.253-.072v6h0a3.368,3.368,0,0,1-.15.978,1.242,1.242,0,0,1-1.154.968H80.62a1.247,1.247,0,0,1-1.16-.968,3.431,3.431,0,0,1-.15-.978c0-.023,0-.043,0-.017V41.461h.646v7.911h0a2.765,2.765,0,0,0,.117.775c.124.34.262.52.545.524h23.85c.28,0,.417-.184.54-.524a2.751,2.751,0,0,0,.118-.775c0-.023,0-.043,0-.017v-7.8l.646.664.688.046.374.941Z"
          transform="translate(-25.64 -18.187)"
          fill="#db9e00"
        />
        <path
          id="Path_21030"
          data-name="Path 21030"
          d="M141.089,8.534l-.437-.159-2.958.616,8.926-1.861c0,.693,5.238,10.845,7.928,16.013H141.089Z"
          transform="translate(-106.124 -3.127)"
          fill="#f2f2f2"
        />
        <path
          id="Path_21031"
          data-name="Path 21031"
          d="M174.691,27.722h-2.836V11.711l5.768-.931-2.932.931Z"
          transform="translate(-148.375 -4.729)"
          fill="#d6d6d6"
        />
        <path
          id="Path_21032"
          data-name="Path 21032"
          d="M171.855,11.712l2.932-.931V27.722h-2.932Z"
          transform="translate(-145.539 -4.729)"
          fill="#f2f2f2"
        />
        <path
          id="Path_21033"
          data-name="Path 21033"
          d="M134.923,9.964l2.958-.616.437.159V24.115H151.78c.928,1.787,1.553,2.979,1.553,2.979h-18.41Z"
          transform="translate(-103.353 -4.1)"
          fill="#d4d4d4"
        />
        <path
          id="Path_21034"
          data-name="Path 21034"
          d="M131.893,44.21H160.07l.461,8.993-25.708-.179Zm4.339,1.9c0-.517-.331-.452-.331-.452h-2.214c-.469,0-.333,1.1-.333,1.1h2.781a1.256,1.256,0,0,0,.1-.646"
          transform="translate(-108.851 -19.393)"
          fill="#db9e00"
        />
        <path
          id="Path_21035"
          data-name="Path 21035"
          d="M175.532,46.8h2.214s.331-.066.331.452a1.256,1.256,0,0,1-.1.646H175.2s-.136-1.1.332-1.1"
          transform="translate(-150.695 -20.526)"
          fill="#ffb800"
        />
        <path
          id="Path_21036"
          data-name="Path 21036"
          d="M208.716,61.235h-1.721l-6.384-.21-1.363-.045a7.055,7.055,0,0,1-.708-1.923c0-.557,1.863-.916,1.863-.916l-.5,1.045h9.423Z"
          transform="translate(-195.052 -25.504)"
          fill="#5f6061"
        />
        <path
          id="Path_21037"
          data-name="Path 21037"
          d="M207.249,51.379l-3.544.463.408-1.14,2.485-.3,1.543-4.309-2.343-.249v-.08l.486.056,2.7.312Z"
          transform="translate(-197.613 -20.074)"
          fill="#db9e00"
        />
        <path
          id="Path_21038"
          data-name="Path 21038"
          d="M209.894,46.115l-1.543,4.309-2.485.3-.191.023-.469.056,1.861-4.808v-.181l.484.052Z"
          transform="translate(-199.367 -20.097)"
          fill="#ec1c24"
        />
        <path
          id="Path_21039"
          data-name="Path 21039"
          d="M75.567,38.2l-.374-.941-2.373-5.977,3.063-1.216,2.952,7.437.376.945Z"
          transform="translate(5.631 -13.191)"
          fill="#3b3c3d"
        />
        <path
          id="Path_21040"
          data-name="Path 21040"
          d="M67.3,62.563l-.021-.052-.323-.814-.484.192L65.569,59.6l.484-.192-2.63-6.623,3.542-.008,2.15,5.416L69.6,58l.907,2.287-.483.191.344.866-.652.258-1.759.7Z"
          transform="translate(19.61 -23.154)"
          fill="#3b3c3d"
        />
        <path
          id="Path_21041"
          data-name="Path 21041"
          d="M57.527,84.308l1.759-.7.365-.145.582,1.467H57.284l-.18-.456Z"
          transform="translate(33.431 -36.613)"
          fill="#3b3c3d"
        />
        <path
          id="Path_21042"
          data-name="Path 21042"
          d="M144.329,29.919l2.63,6.623-.484.193.908,2.286.484-.192.323.814-2.71,3.4c-.591-.506-1.2-.8-1.5-.52-.159.145-.341.313-.521.481a8.024,8.024,0,0,0-2.883-.656,2.674,2.674,0,0,0-.281-.052l.076.009.025-.208c.159-1.329-4.166-1.877-4.329-.516l-.008.076-2.9-.427.018-.159c.158-1.329-4.166-1.876-4.329-.515l-.005.044-2.762-.4-.141-.021.015-.132c.159-1.329-4.166-1.876-4.327-.516l-.007.062q-1.425-.16-2.874-.283l.008-.107c.085-1.026-2.458-1.49-3.691-1.03l-.012-1.9-34.183.217L68.828,40.9l-1.974-5.1,6.384.21h1.721l.606-2.049H66.142L67.6,30.933l.191-.023-.408,1.14,3.544-.463,1.735-5.247-2.7-.312.217-.451.088.008,2.1.2L83.951,5.912l.656-1.126L102.4.644l1.687,3.421-.118.3s.111.012.28.026L113.7,23.557h1.263V31.45c0-.026,0-.006,0,.018a3.46,3.46,0,0,0,.15.978,1.246,1.246,0,0,0,1.16.968h23.852a1.242,1.242,0,0,0,1.154-.968,3.368,3.368,0,0,0,.15-.978h0v-6l.252.073-.023-.3.833.057,3.643.248,1.275.087,2.474,4.276-2.015,0ZM90.544,6.334l-5.768.931V23.276h5.768ZM109.722,20.3h0c-2.691-5.168-7.928-15.32-7.928-16.013L92.866,6.146v17.13h18.41s-.625-1.191-1.553-2.979m2.793,4.8H84.338l2.931,8.814,25.707.179Zm33.258,3.593a1.111,1.111,0,1,0-1.111-1.111,1.111,1.111,0,0,0,1.111,1.111"
          transform="translate(-61.295 -0.284)"
          fill="#ffb800"
        />
        <g transform="matrix(1, 0, 0, 1, -9, 0)" filter="url(#Path_21043)">
          <path
            id="Path_21043-2"
            data-name="Path 21043"
            d="M71.122,77.418c.371-.008.831-.013,1.225-.016a9.223,9.223,0,0,1,.941-2.223c-.207-.194-.4-.376-.508-.5-.692-.748,2.13-3.864,2.924-3.141.217.2.472.434.712.658a7.528,7.528,0,0,1,1.71-.61c.1-.024.208-.051.315-.072a.112.112,0,0,1,.011-.012,8.714,8.714,0,0,1,1.989-.725,3.1,3.1,0,0,1,1.033-.3c1.787-.218,3.785-.459,5.938-.7l-.012-.106c-.157-1.3,3.758-1.8,4.27-.7a2.97,2.97,0,0,1,1.522.185l1.253-.122-.005-.091c-.087-1.364,4.23-1.611,4.347-.292q1.369-.111,2.772-.211l0-.1c-.072-1.37,4.283-1.564,4.353-.228l0,.06q1.567-.083,3.158-.145l-.005-.139c-.041-1.37,4.317-1.47,4.357-.132l.005.147q1.424-.024,2.852-.024v-.039c-.014-1.371,4.345-1.384,4.358-.045l0,.14q1.413.039,2.816.107l.015-.183c.026-.315.283-.533.653-.671,1.233-.46,3.775,0,3.69,1.03l-.008.107q1.448.122,2.873.283l.007-.062c.162-1.36,4.486-.812,4.327.516L135,69.2l.141.021,2.762.4.005-.044c.163-1.362,4.487-.814,4.329.515l-.018.159,2.9.427.009-.076c.162-1.361,4.487-.812,4.328.516l-.025.209-.076-.009c.176.029.281.048.281.052a8.036,8.036,0,0,1,2.883.656c.181-.168.363-.335.522-.481.305-.278.912.015,1.5.52a5.856,5.856,0,0,1,.491.473l-2.816,1.251c-.078-.12-.172-.179-.287-.135l-.2.077a7.331,7.331,0,0,0-3.82-.994s-14.916-2.419-19.926-2.907c-4.7-.458-12.739-.627-18.864-.568-7.175.07-20.561,1.845-28.488,3.475-9.037,1.859-9.722,13.754,0,14.317,5.1.295,31.241.358,41.652.327,10.411.031,20.525-.033,25.626-.327a9.491,9.491,0,0,0,1.127-.139.99.99,0,0,1-.4-.305,1.451,1.451,0,0,0-1.3,0,.979.979,0,1,1,0-1.182,1.47,1.47,0,0,0,1.3,0,.974.974,0,1,1,1.529,1.206,6.87,6.87,0,0,0,3.347-2.318l2.788.011c-.031.059-.057.12-.089.178.106.1.2.2.265.265.692.748-2.13,3.864-2.922,3.142l-.455-.418a8.523,8.523,0,0,1-3.46.847c0,.052,0,.107,0,.157-.01,1.073-4.214,1.015-4.29,0,0-.038-.005-.091-.007-.14q-1.516,0-2.954,0c0,.047,0,.1,0,.143-.01,1.073-4.215,1.015-4.291,0,0-.04-.005-.1-.007-.147l-2.953,0c0,.049,0,.1,0,.149-.01,1.073-4.215,1.015-4.291,0,0-.042,0-.1-.007-.151h-2.953c0,.05,0,.1,0,.151-.01,1.073-4.214,1.015-4.29,0,0-.04-.005-.1-.007-.149q-1.628,0-2.953,0c0,.05,0,.1,0,.147-.01,1.073-4.214,1.015-4.29,0,0-.038-.006-.09-.007-.139l-1.682.006-1.272,0c0,.045,0,.094,0,.137-.009,1.073-4.213,1.015-4.29,0,0-.04-.005-.094-.007-.145-.877,0-1.864,0-2.953,0,0,.05,0,.1,0,.149-.01,1.073-4.215,1.015-4.29,0,0-.042-.006-.1-.007-.151H98.873c0,.05,0,.1,0,.151-.01,1.073-4.215,1.015-4.291,0,0-.04-.006-.1-.007-.149l-2.953,0c0,.048,0,.1,0,.147-.009,1.073-4.213,1.015-4.29,0,0-.039-.006-.094-.007-.143l-2.953,0c0,.046,0,.1,0,.14-.01,1.073-4.215,1.015-4.291,0,0-.038,0-.09-.007-.137a8.513,8.513,0,0,1-4.222-1.05c-.223.207-.454.421-.653.6-.793.722-3.613-2.394-2.924-3.142.132-.143.379-.377.637-.615a8.818,8.818,0,0,1-.783-2.438c-.377.006-.751.007-.96-.006-1.015-.066-1.115-4.27-.042-4.29m75.432,7.929a.669.669,0,1,0,.669.667.669.669,0,0,0-.669-.667m2.854,0a.669.669,0,1,0,.669.667.668.668,0,0,0-.669-.667"
            transform="translate(-61.36 -29.3)"
            fill="#505152"
          />
        </g>
        <path
          id="Path_21044"
          data-name="Path 21044"
          d="M68.725,84.258l-.565-.3a7.144,7.144,0,0,0-.8-1.749l1.979-.879a9.122,9.122,0,0,1,1.089,2.449c.235,0,.469.005.674.011.311.006.52.368.64.874l-2.267,0-.752-.4Z"
          transform="translate(16.158 -35.677)"
          fill="#505152"
        />
        <path
          id="Path_21045"
          data-name="Path 21045"
          d="M151.763,75.3a.972.972,0,0,0-.818.286,3.653,3.653,0,0,1-.666.069,3.6,3.6,0,0,1-.627-.235.978.978,0,1,0-.15,1.173,1.457,1.457,0,0,1,1.294.166c.013.022.031.041.045.062l-.594.225h-9.86c-1.01,0-.977,1.182-.977,1.182v1.377H112.048l.305.5-.01,4.727h-.749l.226-5.228H90.447v5.286h1.214l.034.03a.428.428,0,0,0,0,.047.465.465,0,0,0,0,.048c-.1.085-.239.211-.239.294a1.7,1.7,0,0,0,.039.2,1.618,1.618,0,0,0,.053.2c.036.075.212.13.342.161.012.03.027.059.042.088-.056.121-.124.294-.088.368a1.85,1.85,0,0,0,.123.166,1.939,1.939,0,0,0,.135.159c.065.051.245.024.377,0,.025.021.051.04.077.06a1.255,1.255,0,0,0,.024.243c-.025,0-.048-.007-.074-.007a.973.973,0,0,0-.776.388,3.725,3.725,0,0,1-.652.153,3.731,3.731,0,0,1-.652-.153.978.978,0,1,0,0,1.182,3.56,3.56,0,0,1,.652-.155,3.554,3.554,0,0,1,.652.155.976.976,0,1,0,1.443-1.3,1.55,1.55,0,0,0,.177-.12c.031.007.061.017.095.024.06.12.152.278.232.3a1.59,1.59,0,0,0,.207.008,1.735,1.735,0,0,0,.208-.008c.079-.017.171-.176.231-.3.032-.007.064-.017.095-.024.014.011.031.023.047.034A.976.976,0,1,0,95.8,88.517a3.57,3.57,0,0,1,.652-.155,3.575,3.575,0,0,1,.653.155.979.979,0,1,0,0-1.182,3.747,3.747,0,0,1-.653.153,3.742,3.742,0,0,1-.652-.153.975.975,0,0,0-.619-.369,1.31,1.31,0,0,0,.027-.254l.076-.058c.131.027.313.053.376,0A1.51,1.51,0,0,0,95.8,86.5a1.723,1.723,0,0,0,.125-.168c.035-.074-.031-.245-.088-.368l.041-.088c.129-.03.306-.086.342-.159a1.67,1.67,0,0,0,.053-.2,1.7,1.7,0,0,0,.039-.2c0-.083-.135-.209-.239-.294,0-.016,0-.031,0-.048s0-.031,0-.047l.034-.03h5.787l.034.03c0,.016,0,.031,0,.047s0,.032,0,.048c-.1.085-.238.211-.238.294a1.847,1.847,0,0,0,.038.2,1.652,1.652,0,0,0,.055.2c.035.075.211.13.342.161.012.03.027.059.041.088-.056.121-.123.294-.087.368a1.624,1.624,0,0,0,.123.166,1.718,1.718,0,0,0,.136.159c.064.051.244.024.377,0,.025.021.051.04.076.06a.82.82,0,0,0,.056.332,1,1,0,0,0-.361.291,3.742,3.742,0,0,1-.652.153,3.725,3.725,0,0,1-.652-.153.978.978,0,1,0,0,1.182,1.445,1.445,0,0,1,1.3,0,.975.975,0,0,0,1.609-1.1h.024a1.708,1.708,0,0,0,.207-.008c.08-.017.172-.176.231-.3.032-.007.064-.017.1-.024.106.083.259.186.339.168a.96.96,0,0,0,.137-.058.975.975,0,1,0,1.43,1.313,1.447,1.447,0,0,1,1.305,0,.979.979,0,1,0,0-1.182,1.471,1.471,0,0,1-1.305,0,.972.972,0,0,0-.775-.388.983.983,0,0,0-.379.076.983.983,0,0,0,.042-.312l.077-.058c.131.027.313.053.376,0a1.532,1.532,0,0,0,.135-.157,1.637,1.637,0,0,0,.125-.168c.035-.074-.031-.245-.088-.368.015-.029.028-.058.041-.088.13-.03.307-.086.343-.159a1.673,1.673,0,0,0,.053-.2,1.784,1.784,0,0,0,.039-.2c0-.083-.135-.209-.239-.294,0-.016,0-.031,0-.048s0-.031,0-.047l.034-.03h5.787l.034.03c0,.016,0,.031,0,.047s0,.032,0,.048c-.1.085-.239.211-.239.294a1.847,1.847,0,0,0,.038.2,1.557,1.557,0,0,0,.055.2c.034.072.2.126.327.157v.177h.02a.449.449,0,0,0-.051.283,1.586,1.586,0,0,0,.124.166,1.651,1.651,0,0,0,.135.159c.063.051.244.024.376,0,.024.021.051.04.077.06,0,.135.016.318.079.37a1.99,1.99,0,0,0,.184.1l.069.033a1.028,1.028,0,0,0-.118.124,1.47,1.47,0,0,1-1.3,0,.978.978,0,1,0,0,1.182,1.446,1.446,0,0,1,1.3,0,.975.975,0,1,0,1.478-1.268c.027-.044.052-.089.073-.131.031-.007.065-.017.1-.024.106.083.259.186.338.168a1.487,1.487,0,0,0,.192-.083,2.037,2.037,0,0,0,.184-.1c.063-.052.078-.235.079-.37l.079-.058c.13.027.312.053.375,0a1.455,1.455,0,0,0,.135-.157,1.826,1.826,0,0,0,.125-.168.422.422,0,0,0-.044-.267l6.234.025a.377.377,0,0,0-.035.242,1.744,1.744,0,0,0,.123.166,1.562,1.562,0,0,0,.136.159c.064.051.244.024.376,0,.025.021.051.04.077.06,0,.135.015.318.08.37a1.821,1.821,0,0,0,.184.1,1.424,1.424,0,0,0,.19.083c.079.019.232-.085.34-.168.031.007.062.017.1.024.006.013.015.028.022.042a.989.989,0,0,0-.177.176,1.468,1.468,0,0,1-1.3,0,.978.978,0,1,0,0,1.182,1.445,1.445,0,0,1,1.3,0,.975.975,0,1,0,1.484-1.262c.037-.012.109-.045.173-.076a2.037,2.037,0,0,0,.184-.1c.063-.052.078-.235.079-.37l.077-.058c.13.027.312.053.376,0a1.582,1.582,0,0,0,.136-.157,2.034,2.034,0,0,0,.124-.168.358.358,0,0,0-.031-.226l6.206.025a.315.315,0,0,0-.022.2,1.885,1.885,0,0,0,.124.166,1.635,1.635,0,0,0,.136.159c.063.051.244.024.377,0,.024.021.05.04.076.06,0,.135.015.318.08.37a1.739,1.739,0,0,0,.183.1,1.423,1.423,0,0,0,.19.083c.08.019.233-.085.338-.168.033.007.063.017.1.024a.852.852,0,0,0,.184.268,3.954,3.954,0,0,1-.47.1,3.707,3.707,0,0,1-.652-.153.978.978,0,1,0,0,1.182,3.538,3.538,0,0,1,.652-.155,3.581,3.581,0,0,1,.652.155.976.976,0,1,0,1.291-1.419l.027-.016c.065-.052.079-.235.08-.37l.077-.058c.13.027.312.053.375,0a1.444,1.444,0,0,0,.136-.157,2.073,2.073,0,0,0,.125-.168.292.292,0,0,0-.017-.185l2.635.011a.9.9,0,0,0,.911.732h13.946a.883.883,0,0,0,.892-.669l.527,0a6.865,6.865,0,0,1-3.347,2.317.974.974,0,1,0-1.529-1.205,1.47,1.47,0,0,1-1.3,0,.978.978,0,1,0,0,1.182,1.446,1.446,0,0,1,1.3,0,.989.989,0,0,0,.4.3,9.483,9.483,0,0,1-1.127.14c-5.1.294-15.215.358-25.626.327-10.412.031-36.551-.033-41.653-.327-9.722-.564-9.036-12.458,0-14.317,7.928-1.631,21.314-3.406,28.489-3.475,6.124-.06,14.167.111,18.864.568,5.011.488,19.926,2.907,19.926,2.907a7.327,7.327,0,0,1,3.821.994l-1.363.518a.976.976,0,0,0-.843-.852m-8.344,13.6a.979.979,0,0,0,.775-.387,1.446,1.446,0,0,1,1.3,0,.979.979,0,1,0,0-1.182,1.47,1.47,0,0,1-1.3,0,.976.976,0,1,0-.775,1.568m-5.377,0a.979.979,0,0,0,.775-.387,1.446,1.446,0,0,1,1.3,0,.979.979,0,1,0,0-1.182,1.47,1.47,0,0,1-1.3,0,.977.977,0,1,0-.775,1.568m-10.754,0a.98.98,0,0,0,.776-.387,3.538,3.538,0,0,1,.652-.155,3.581,3.581,0,0,1,.652.155.979.979,0,1,0,0-1.182,3.754,3.754,0,0,1-.652.153,3.707,3.707,0,0,1-.652-.153.977.977,0,1,0-.776,1.568m-10.753,0a.977.977,0,0,0,.775-.387,1.447,1.447,0,0,1,1.305,0,.979.979,0,1,0,0-1.182,1.471,1.471,0,0,1-1.305,0,.976.976,0,1,0-.775,1.568M88.055,76.1a.974.974,0,0,0-1.836-.215,3.647,3.647,0,0,1-.607.284,3.586,3.586,0,0,1-.67-.015A.975.975,0,1,0,84,77.816c-.072.049-.143.1-.205.148-.065-.016-.13-.036-.2-.05a3.744,3.744,0,0,0-.187-.33c-.1-.145-.2-.265-.3-.286a.226.226,0,0,0-.044-.007c-.085-.008-.251-.009-.39-.009a3.608,3.608,0,0,0-.433.016c-.165.039-.357.367-.482.616-.067.014-.131.034-.2.05-.221-.171-.542-.388-.707-.35a3.436,3.436,0,0,0-.4.175,3.579,3.579,0,0,0-.384.2c-.134.107-.164.491-.167.772-.053.041-.107.08-.159.124-.273-.06-.652-.116-.784-.01a3.2,3.2,0,0,0-.283.33,3.51,3.51,0,0,0-.258.349c-.074.154.066.514.184.767-.031.059-.06.121-.088.181-.273.065-.639.18-.713.334a3.282,3.282,0,0,0-.111.418,3.153,3.153,0,0,0-.081.426c0,.171.28.435.5.611,0,.034-.006.067-.006.1s0,.066.006.1c-.218.178-.5.441-.5.611a3.717,3.717,0,0,0,.08.426,3.558,3.558,0,0,0,.113.418c.074.155.44.269.713.335.028.061.057.122.088.181-.119.253-.258.614-.184.766a3.455,3.455,0,0,0,.258.348,3.218,3.218,0,0,0,.283.33c.132.106.51.051.784-.008.052.044.106.083.159.123,0,.281.034.665.167.772a5.6,5.6,0,0,0,.781.377c.166.038.486-.179.707-.351.066.016.13.036.2.05.125.25.317.58.482.617a3.385,3.385,0,0,0,.433.016,3.493,3.493,0,0,0,.434-.016c.164-.037.357-.367.483-.617.066-.012.131-.034.2-.049.07.053.149.109.23.163a.976.976,0,1,0,1.026,1.533,3.564,3.564,0,0,1,.653-.155,3.56,3.56,0,0,1,.652.155.979.979,0,1,0,0-1.182,3.731,3.731,0,0,1-.652.153,3.736,3.736,0,0,1-.653-.153.987.987,0,0,0-.309-.264L84.9,87a3.655,3.655,0,0,0,.384-.2c.132-.107.163-.491.166-.771.053-.042.109-.08.161-.123.273.059.651.114.785.008a3.256,3.256,0,0,0,.282-.328,3.6,3.6,0,0,0,.259-.349c.073-.153-.065-.511-.185-.766.031-.06.059-.12.088-.182.271-.066.639-.179.713-.333a3.558,3.558,0,0,0,.111-.419,3.511,3.511,0,0,0,.081-.426c0-.17-.281-.433-.5-.611,0-.034.006-.066.006-.1s0-.067-.006-.1c.218-.176.5-.44.5-.611a3.862,3.862,0,0,0-.082-.425,3.548,3.548,0,0,0-.112-.419c-.074-.154-.442-.269-.713-.334-.029-.061-.057-.122-.088-.181.12-.253.258-.613.185-.767a6.209,6.209,0,0,0-.541-.678c-.134-.106-.511-.051-.785.01-.052-.044-.107-.083-.159-.124,0-.281-.034-.665-.167-.772a3.636,3.636,0,0,0-.384-.2l-.112-.053a.983.983,0,0,0,.4-.426,3.6,3.6,0,0,1,.606-.286,3.462,3.462,0,0,1,.67.017.975.975,0,0,0,1.592-.942m5.384-.972a.975.975,0,0,0-1.833-.241,3.694,3.694,0,0,1-.61.276,3.631,3.631,0,0,1-.669-.026.979.979,0,1,0,.227,1.16,3.541,3.541,0,0,1,.61-.277,3.548,3.548,0,0,1,.67.026.974.974,0,0,0,1.606-.918m5.406-.825a.975.975,0,0,0-1.81-.38,3.737,3.737,0,0,1-.629.228,3.6,3.6,0,0,1-.666-.076.978.978,0,1,0,.139,1.174,3.573,3.573,0,0,1,.63-.229,3.512,3.512,0,0,1,.666.076.974.974,0,0,0,1.671-.793m5.675.273c-.079.019-.172.176-.23.3-.034.007-.065.016-.1.024-.106-.082-.26-.187-.339-.168l-.009,0a.976.976,0,1,0-1.416-1.3,3.672,3.672,0,0,1-.636.211,3.622,3.622,0,0,1-.663-.095.979.979,0,1,0,.1,1.178,3.563,3.563,0,0,1,.636-.212,3.608,3.608,0,0,1,.664.1.972.972,0,0,0,.807.317,1.025,1.025,0,0,0,.151-.029l-.012.007c-.064.051-.079.236-.08.37l-.076.058c-.131-.028-.313-.053-.377,0a1.637,1.637,0,0,0-.136.158,1.882,1.882,0,0,0-.123.167c-.036.075.031.246.087.368-.015.029-.029.058-.042.088-.13.03-.306.085-.341.16a1.4,1.4,0,0,0-.053.2,1.506,1.506,0,0,0-.04.2c0,.081.135.208.239.294q0,.023,0,.047c0,.016,0,.031,0,.048-.1.084-.239.212-.239.293a1.8,1.8,0,0,0,.038.2,1.611,1.611,0,0,0,.055.2c.035.075.211.13.341.16.013.03.027.06.042.088-.056.122-.123.294-.087.369a1.631,1.631,0,0,0,.123.165,1.728,1.728,0,0,0,.136.159c.064.051.244.024.377,0,.024.02.051.04.076.059,0,.134.016.319.08.371a1.884,1.884,0,0,0,.184.1,1.657,1.657,0,0,0,.191.083c.079.02.232-.086.339-.167.031.007.062.018.1.023.058.12.151.279.23.3a1.4,1.4,0,0,0,.208.007,1.645,1.645,0,0,0,.207-.007c.079-.017.172-.176.232-.3.031-.005.064-.016.095-.023.106.081.259.187.338.168a1.9,1.9,0,0,0,.191-.083c.071-.034.161-.08.184-.1.063-.052.077-.237.079-.371.027-.019.053-.039.078-.058.13.028.312.054.375,0a1.4,1.4,0,0,0,.136-.157c.051-.064.112-.143.125-.167.035-.075-.031-.245-.089-.369.016-.028.028-.057.042-.088.13-.03.308-.085.344-.16a1.832,1.832,0,0,0,.053-.2,1.862,1.862,0,0,0,.039-.2c0-.081-.136-.209-.239-.293,0-.017,0-.032,0-.048s0-.032,0-.047c.1-.086.239-.212.239-.294a2.957,2.957,0,0,0-.092-.4c-.036-.075-.213-.13-.344-.16-.013-.03-.026-.06-.042-.088.057-.122.124-.293.089-.368a1.686,1.686,0,0,0-.125-.167,1.51,1.51,0,0,0-.136-.158c-.063-.049-.245-.024-.376,0-.024-.02-.05-.039-.077-.058,0-.135-.016-.319-.079-.37a1.9,1.9,0,0,0-.184-.1,1.537,1.537,0,0,0-.191-.084c-.079-.019-.233.086-.338.168l-.095-.024a1.639,1.639,0,0,0-.089-.159c-.047-.068-.1-.127-.143-.137l-.02,0c-.041,0-.121,0-.187,0a1.827,1.827,0,0,0-.208.006m5.08-1.264a.975.975,0,0,0-1.808-.392,3.675,3.675,0,0,1-.63.223,3.568,3.568,0,0,1-.666-.08.978.978,0,1,0,.131,1.175,1.449,1.449,0,0,1,1.3-.144.975.975,0,0,0,1.677-.782m4.35-1.3a.97.97,0,0,0-.751.434,3.68,3.68,0,0,1-.641.193,3.594,3.594,0,0,1-.66-.113.978.978,0,1,0,.073,1.18,1.451,1.451,0,0,1,1.3-.081.976.976,0,1,0,.677-1.614m1.384,2.65c-.033.006-.064.016-.1.024-.106-.082-.26-.187-.339-.169a1.606,1.606,0,0,0-.19.084,1.507,1.507,0,0,0-.184.1c-.064.051-.079.236-.08.37l-.077.059c-.131-.029-.313-.054-.377,0a1.506,1.506,0,0,0-.136.158c-.049.063-.111.143-.123.167-.035.075.031.246.088.368a.9.9,0,0,0-.041.088c-.131.03-.307.085-.342.159a1.541,1.541,0,0,0-.053.2,1.63,1.63,0,0,0-.039.2c0,.081.135.208.238.294,0,.016,0,.031,0,.047s0,.032,0,.049c-.1.084-.238.211-.238.293a1.674,1.674,0,0,0,.038.2,1.713,1.713,0,0,0,.054.2c.035.075.212.13.342.161a.781.781,0,0,0,.041.088c-.057.122-.123.294-.088.368a1.759,1.759,0,0,0,.123.166,2.006,2.006,0,0,0,.136.159c.064.051.245.024.377,0,.025.02.051.04.077.058,0,.135.016.319.08.37a1.888,1.888,0,0,0,.184.1,1.53,1.53,0,0,0,.19.083c.079.019.232-.085.339-.168.031.008.062.019.1.024.058.12.151.279.231.3a1.379,1.379,0,0,0,.208.007,1.659,1.659,0,0,0,.208-.007c.08-.017.172-.176.231-.3.032-.005.065-.016.095-.024.106.083.26.187.34.169a1.948,1.948,0,0,0,.191-.084,1.865,1.865,0,0,0,.184-.1c.064-.051.078-.236.079-.37.026-.019.053-.038.077-.058.13.028.312.054.376,0a1.425,1.425,0,0,0,.135-.157,1.652,1.652,0,0,0,.124-.168c.036-.074-.031-.245-.088-.368.015-.028.028-.057.042-.088.13-.031.307-.085.342-.16a1.59,1.59,0,0,0,.053-.2,1.831,1.831,0,0,0,.038-.2c0-.082-.135-.209-.239-.293,0-.017,0-.033,0-.049s0-.031,0-.047c.1-.086.239-.213.239-.294a1.887,1.887,0,0,0-.038-.2,1.538,1.538,0,0,0-.053-.2c-.035-.074-.213-.129-.342-.159-.014-.03-.026-.06-.042-.088.057-.122.124-.293.088-.368a1.443,1.443,0,0,0-.124-.167,1.523,1.523,0,0,0-.135-.158c-.064-.051-.246-.025-.377,0-.024-.02-.05-.04-.076-.059,0-.134-.015-.319-.079-.37a1.491,1.491,0,0,0-.184-.1,1.733,1.733,0,0,0-.191-.084c-.079-.018-.234.087-.34.169-.03-.008-.063-.017-.095-.024-.025-.051-.056-.107-.088-.159-.047-.07-.1-.127-.143-.137a.071.071,0,0,0-.021,0,1.815,1.815,0,0,0-.187-.006,1.743,1.743,0,0,0-.208.007c-.08.019-.172.176-.231.3M119.39,72.1a.971.971,0,0,0-.775.387,1.461,1.461,0,0,1-1.305,0,.978.978,0,1,0,0,1.182,1.466,1.466,0,0,1,1.305,0,.976.976,0,1,0,.775-1.568m5.447.111a.971.971,0,0,0-.8.326,1.459,1.459,0,0,1-1.3-.1.979.979,0,1,0-.09,1.178,1.456,1.456,0,0,1,1.3.1.976.976,0,1,0,.892-1.506m5.381.509a.969.969,0,0,0-.8.324,3.732,3.732,0,0,1-.664.1,3.588,3.588,0,0,1-.638-.206.979.979,0,1,0-.1,1.178,3.606,3.606,0,0,1,.663-.1,3.505,3.505,0,0,1,.638.207.976.976,0,1,0,.9-1.5m1.258,3.736a1.692,1.692,0,0,0-.053-.2c-.036-.075-.213-.13-.342-.161-.015-.03-.026-.059-.042-.089.057-.121.123-.292.088-.367A1.681,1.681,0,0,0,131,75.47a1.62,1.62,0,0,0-.136-.158c-.063-.05-.245-.024-.377,0-.024-.02-.049-.04-.076-.06,0-.134-.016-.318-.079-.37a2.017,2.017,0,0,0-.184-.1,1.661,1.661,0,0,0-.191-.084c-.079-.019-.234.087-.339.169-.031-.008-.063-.017-.095-.024a1.448,1.448,0,0,0-.089-.159c-.047-.069-.1-.127-.142-.138l-.021,0c-.04,0-.121,0-.187,0a1.665,1.665,0,0,0-.208.007c-.079.018-.172.176-.23.3-.034.007-.065.016-.1.024-.106-.082-.26-.188-.34-.169a1.621,1.621,0,0,0-.19.084,1.849,1.849,0,0,0-.184.1c-.065.052-.079.237-.08.37-.026.019-.052.039-.077.06-.131-.029-.312-.054-.376,0a1.542,1.542,0,0,0-.136.157c-.049.064-.111.143-.123.168-.035.074.031.246.088.367-.015.03-.029.058-.042.089-.131.03-.306.085-.342.161a1.41,1.41,0,0,0-.053.2,1.719,1.719,0,0,0-.039.2c0,.082.135.208.239.294,0,.016,0,.031,0,.047s0,.032,0,.048c-.1.085-.239.211-.239.294a1.811,1.811,0,0,0,.038.2,1.68,1.68,0,0,0,.054.2c.036.075.212.13.342.161a.973.973,0,0,0,.042.088c-.057.122-.124.294-.088.368a1.76,1.76,0,0,0,.123.166,1.591,1.591,0,0,0,.136.158c.064.051.244.025.376,0,.025.02.051.039.077.058,0,.135.015.318.08.37a2.959,2.959,0,0,0,.374.18c.08.019.233-.086.34-.168.031.008.062.018.1.024.058.119.151.279.23.3a1.448,1.448,0,0,0,.208.007,1.747,1.747,0,0,0,.208-.007c.079-.017.172-.175.231-.3.031-.006.064-.016.095-.024.106.082.26.187.339.168a1.77,1.77,0,0,0,.191-.084,1.857,1.857,0,0,0,.184-.1c.063-.052.078-.236.079-.37.027-.02.052-.038.077-.058.13.028.312.053.376,0a1.347,1.347,0,0,0,.136-.157,1.761,1.761,0,0,0,.124-.167c.035-.074-.031-.245-.088-.368.015-.029.027-.058.042-.088.13-.03.307-.085.342-.161a1.758,1.758,0,0,0,.053-.2,1.663,1.663,0,0,0,.039-.2c0-.083-.136-.209-.239-.294,0-.016,0-.031,0-.048s0-.031,0-.047c.1-.086.239-.212.239-.294a1.759,1.759,0,0,0-.039-.2m4.153-3.17a.972.972,0,0,0-.817.291,1.46,1.46,0,0,1-1.294-.159.978.978,0,1,0-.143,1.173,1.457,1.457,0,0,1,1.294.159.976.976,0,1,0,.96-1.463m5.394.538a.973.973,0,0,0-.823.272,3.659,3.659,0,0,1-.667.058,3.572,3.572,0,0,1-.624-.245.978.978,0,1,0-.17,1.17,3.429,3.429,0,0,1,.668-.06,3.59,3.59,0,0,1,.623.247.976.976,0,1,0,.993-1.442m5.359.971a.971.971,0,0,0-.816.29,1.46,1.46,0,0,1-1.3-.157.978.978,0,1,0-.143,1.173,1.458,1.458,0,0,1,1.3.158.976.976,0,1,0,.959-1.464"
          transform="translate(-72.601 -31.214)"
          fill="#3b3c3d"
        />
        <path
          id="Path_21046"
          data-name="Path 21046"
          d="M145.154,76.856c.066,0,.146,0,.187.005a.072.072,0,0,1,.021,0c.046.01.1.068.143.137a1.689,1.689,0,0,1,.089.16c.031.006.064.015.094.023.106-.081.26-.187.34-.169a2,2,0,0,1,.191.084,1.59,1.59,0,0,1,.184.1c.063.052.078.236.079.37.027.02.053.039.076.059.131-.029.313-.054.377,0a1.438,1.438,0,0,1,.135.158,1.376,1.376,0,0,1,.124.167c.036.075-.031.246-.088.368.015.029.027.058.042.088.13.03.307.086.343.159a1.691,1.691,0,0,1,.053.2,1.921,1.921,0,0,1,.039.2c0,.081-.135.208-.239.294,0,.016,0,.031,0,.047s0,.032,0,.049c.1.084.239.211.239.292a1.863,1.863,0,0,1-.039.2,1.662,1.662,0,0,1-.053.2c-.036.075-.213.13-.343.16-.014.03-.026.06-.042.088.057.122.123.294.088.368a1.633,1.633,0,0,1-.124.167,1.369,1.369,0,0,1-.135.157c-.064.051-.246.024-.376,0-.025.02-.051.04-.078.058,0,.135-.015.319-.079.371a1.912,1.912,0,0,1-.184.1c-.073.035-.163.076-.191.084-.079.018-.234-.086-.34-.169-.03.008-.063.019-.094.024-.059.121-.152.278-.231.3a1.66,1.66,0,0,1-.208.007,1.383,1.383,0,0,1-.208-.007c-.079-.017-.172-.176-.231-.3-.033-.006-.064-.016-.1-.024-.107.083-.259.187-.339.167a1.568,1.568,0,0,1-.19-.083,1.914,1.914,0,0,1-.184-.1c-.064-.052-.079-.236-.08-.371-.026-.019-.052-.038-.076-.058-.132.028-.313.054-.377,0a1.713,1.713,0,0,1-.136-.159,1.647,1.647,0,0,1-.123-.166c-.036-.074.031-.245.088-.368a.792.792,0,0,1-.041-.088c-.131-.03-.307-.085-.342-.161a1.766,1.766,0,0,1-.054-.2,1.8,1.8,0,0,1-.038-.2c0-.081.135-.209.238-.292,0-.017,0-.033,0-.049s0-.031,0-.047c-.1-.086-.238-.213-.238-.294a1.65,1.65,0,0,1,.039-.2,1.668,1.668,0,0,1,.053-.2c.035-.074.212-.129.342-.159a.964.964,0,0,1,.041-.088c-.057-.121-.123-.293-.088-.368a1.912,1.912,0,0,1,.123-.167,1.364,1.364,0,0,1,.136-.157c.063-.051.245-.025.377,0l.076-.059c0-.134.016-.318.08-.37a1.591,1.591,0,0,1,.184-.1,1.88,1.88,0,0,1,.19-.084c.08-.018.234.088.339.169.031-.008.062-.017.1-.023.058-.121.152-.278.231-.3a1.782,1.782,0,0,1,.208-.007M143.9,79.3a1.143,1.143,0,1,0,1.142-1.142A1.143,1.143,0,0,0,143.9,79.3"
          transform="translate(-101.983 -33.713)"
          fill="#48494a"
        />
        <path
          id="Path_21047"
          data-name="Path 21047"
          d="M147.5,80.312a1.143,1.143,0,1,1-1.143-1.142,1.143,1.143,0,0,1,1.143,1.142"
          transform="translate(-103.295 -34.729)"
          fill="#707173"
        />
        <path
          id="Path_21048"
          data-name="Path 21048"
          d="M165.037,77.239c.046.01.1.068.143.137a1.637,1.637,0,0,1,.089.159l.095.024c.106-.082.259-.187.338-.168a1.537,1.537,0,0,1,.191.084,1.89,1.89,0,0,1,.184.1c.063.051.077.236.079.37.027.019.053.038.077.058.131-.028.313-.053.376,0a1.511,1.511,0,0,1,.136.158,1.689,1.689,0,0,1,.125.167c.035.075-.031.246-.089.368.016.029.028.058.042.088.13.03.308.085.344.16a2.963,2.963,0,0,1,.092.4c0,.081-.136.208-.239.294,0,.015,0,.031,0,.047s0,.031,0,.048c.1.084.239.212.239.293a1.863,1.863,0,0,1-.039.2,1.834,1.834,0,0,1-.053.2c-.036.075-.213.13-.344.16-.013.03-.026.06-.042.088.057.123.124.294.089.369-.013.024-.074.1-.125.167a1.4,1.4,0,0,1-.136.157c-.063.051-.245.024-.375,0-.025.02-.051.039-.078.058,0,.134-.016.319-.079.371-.024.017-.113.062-.184.1a1.909,1.909,0,0,1-.191.083c-.079.019-.233-.086-.338-.168-.031.007-.064.018-.095.023-.06.121-.153.279-.232.3a1.646,1.646,0,0,1-.207.007,1.4,1.4,0,0,1-.208-.007c-.079-.017-.172-.176-.23-.3-.034-.005-.065-.016-.1-.023-.107.081-.26.187-.339.167a1.66,1.66,0,0,1-.191-.083,1.891,1.891,0,0,1-.184-.1c-.064-.052-.079-.237-.08-.371-.025-.019-.052-.039-.076-.059-.132.028-.313.054-.377,0a1.731,1.731,0,0,1-.136-.159,1.627,1.627,0,0,1-.123-.165c-.036-.075.031-.246.087-.369-.015-.028-.029-.057-.042-.088-.13-.03-.307-.085-.341-.16a1.609,1.609,0,0,1-.055-.2,1.793,1.793,0,0,1-.038-.2c0-.081.135-.209.239-.293,0-.017,0-.033,0-.048s0-.032,0-.047c-.1-.086-.239-.212-.239-.294a1.486,1.486,0,0,1,.04-.2,1.4,1.4,0,0,1,.053-.2c.035-.075.211-.13.341-.16.013-.03.027-.06.042-.088-.056-.122-.123-.293-.087-.368a1.875,1.875,0,0,1,.123-.167,1.64,1.64,0,0,1,.136-.158c.064-.049.245-.024.377,0l.076-.058c0-.135.016-.319.08-.37l.012-.007a.954.954,0,0,0,.353-.17l.009,0c.079-.019.234.086.339.168.031-.008.062-.016.1-.024.058-.121.151-.278.23-.3a1.827,1.827,0,0,1,.208-.006c.066,0,.146,0,.187,0l.02,0m-.318,1.293a1.142,1.142,0,1,0,1.142,1.142,1.142,1.142,0,0,0-1.142-1.142"
          transform="translate(-132.703 -33.879)"
          fill="#48494a"
        />
        <path
          id="Path_21049"
          data-name="Path 21049"
          d="M167.174,80.689a1.142,1.142,0,1,1-1.142-1.142,1.141,1.141,0,0,1,1.142,1.142"
          transform="translate(-134.016 -34.895)"
          fill="#707173"
        />
        <path
          id="Path_21050"
          data-name="Path 21050"
          d="M123.625,79.6c0,.016,0,.03,0,.047s0,.032,0,.048c.1.085.239.211.239.294a1.73,1.73,0,0,1-.039.2,1.778,1.778,0,0,1-.053.2c-.036.075-.213.13-.342.161-.015.03-.026.059-.042.088.057.122.123.294.088.368a1.793,1.793,0,0,1-.125.167,1.407,1.407,0,0,1-.135.157c-.063.051-.245.025-.376,0-.025.02-.051.039-.077.058,0,.135-.016.319-.08.371a1.889,1.889,0,0,1-.184.1,1.781,1.781,0,0,1-.191.083c-.079.019-.233-.086-.338-.168-.031.008-.063.017-.095.024-.06.121-.152.278-.231.3a1.777,1.777,0,0,1-.208.007,1.461,1.461,0,0,1-.208-.007c-.08-.017-.172-.177-.231-.3-.033-.007-.064-.016-.1-.024-.107.081-.259.187-.339.168a1.649,1.649,0,0,1-.19-.083,1.918,1.918,0,0,1-.184-.1c-.064-.052-.079-.236-.079-.371-.026-.019-.053-.038-.077-.058-.132.028-.313.054-.377,0a1.786,1.786,0,0,1-.136-.158,1.646,1.646,0,0,1-.123-.166c-.036-.074.031-.246.088-.368-.015-.029-.029-.058-.042-.088-.13-.03-.306-.086-.342-.161a2.644,2.644,0,0,1-.093-.4c0-.083.135-.208.239-.294,0-.016,0-.031,0-.048s0-.031,0-.047c-.1-.086-.239-.213-.239-.295a1.769,1.769,0,0,1,.04-.2,1.408,1.408,0,0,1,.053-.2c.035-.076.212-.13.342-.161.012-.03.026-.059.042-.089-.057-.121-.123-.293-.088-.367a1.986,1.986,0,0,1,.123-.168,1.639,1.639,0,0,1,.136-.158c.064-.05.245-.024.377.005.026-.02.051-.04.077-.06,0-.134.015-.318.079-.37a1.817,1.817,0,0,1,.184-.1,1.605,1.605,0,0,1,.19-.084c.08-.019.234.088.339.169.031-.007.062-.017.1-.024.058-.121.151-.278.231-.3a1.655,1.655,0,0,1,.208-.007c.066,0,.147,0,.187,0a.1.1,0,0,1,.021,0c.046.01.1.068.143.137a1.674,1.674,0,0,1,.089.159l.095.024c.106-.081.26-.187.338-.169a1.732,1.732,0,0,1,.191.084,1.791,1.791,0,0,1,.184.1c.064.052.078.237.08.37.026.019.052.039.076.06.131-.029.313-.055.377-.005a1.588,1.588,0,0,1,.135.158,1.654,1.654,0,0,1,.125.167c.035.074-.031.246-.088.367.016.03.028.058.042.089.13.03.307.085.342.161a1.693,1.693,0,0,1,.053.2,1.853,1.853,0,0,1,.039.2c0,.082-.136.208-.239.295m-2.3-1.1a1.142,1.142,0,1,0,1.143,1.142,1.142,1.142,0,0,0-1.143-1.142"
          transform="translate(-64.95 -33.864)"
          fill="#48494a"
        />
        <path
          id="Path_21051"
          data-name="Path 21051"
          d="M123.78,80.655a1.142,1.142,0,1,1-1.143-1.142,1.143,1.143,0,0,1,1.143,1.142"
          transform="translate(-66.262 -34.879)"
          fill="#707173"
        />
        <path
          id="Path_21052"
          data-name="Path 21052"
          d="M197.554,99.837a.669.669,0,1,1-.669.667.668.668,0,0,1,.669-.667"
          transform="translate(-183.026 -43.794)"
          fill="#707173"
        />
        <path
          id="Path_21053"
          data-name="Path 21053"
          d="M203.307,100.5a.669.669,0,1,1-.67-.667.67.67,0,0,1,.67.667"
          transform="translate(-190.963 -43.794)"
          fill="#707173"
        />
        <path
          id="Path_21054"
          data-name="Path 21054"
          d="M190.9,99.517a1.482,1.482,0,0,0,.19.084.27.27,0,0,0,.163-.048.976.976,0,1,1-1.443,1.3,1.449,1.449,0,0,0-1.3,0,.979.979,0,1,1,0-1.182,1.468,1.468,0,0,0,1.3,0,.973.973,0,0,1,.776-.388c.025,0,.049.006.074.007a.233.233,0,0,0,.056.127,1.68,1.68,0,0,0,.184.1m-3.17.078a.669.669,0,1,0,.67.667.669.669,0,0,0-.67-.667m2.185.667a.669.669,0,1,0,.671-.667.67.67,0,0,0-.671.667"
          transform="translate(-170.684 -43.552)"
          fill="#505152"
        />
        <path
          id="Path_21055"
          data-name="Path 21055"
          d="M188.646,100.5a.669.669,0,1,1-.668-.667.669.669,0,0,1,.668.667"
          transform="translate(-168.073 -43.794)"
          fill="#707173"
        />
        <path
          id="Path_21056"
          data-name="Path 21056"
          d="M193.061,101.176a.669.669,0,1,1,.67-.671.67.67,0,0,1-.67.671"
          transform="translate(-176.01 -43.794)"
          fill="#707173"
        />
        <path
          id="Path_21057"
          data-name="Path 21057"
          d="M178.075,99.517a1.715,1.715,0,0,0,.184-.1.212.212,0,0,0,.053-.116.981.981,0,0,1,.619.369,3.61,3.61,0,0,0,.652.153,3.666,3.666,0,0,0,.652-.153.978.978,0,1,1,0,1.182,3.541,3.541,0,0,0-.652-.155,3.488,3.488,0,0,0-.652.155.976.976,0,1,1-1.339-1.388c.1.074.223.149.291.134a1.411,1.411,0,0,0,.191-.084m2.935,1.417a.669.669,0,1,0-.669-.671.67.67,0,0,0,.669.671m-3.523-.671a.669.669,0,1,0,.668-.667.67.67,0,0,0-.668.667"
          transform="translate(-155.728 -43.552)"
          fill="#505152"
        />
        <path
          id="Path_21058"
          data-name="Path 21058"
          d="M178.4,99.837a.669.669,0,1,1-.669.667.669.669,0,0,1,.669-.667"
          transform="translate(-153.114 -43.794)"
          fill="#707173"
        />
        <path
          id="Path_21059"
          data-name="Path 21059"
          d="M184.15,100.5a.669.669,0,1,1-.67-.667.671.671,0,0,1,.67.667"
          transform="translate(-161.053 -43.794)"
          fill="#707173"
        />
        <path
          id="Path_21060"
          data-name="Path 21060"
          d="M171.227,99.517a1.465,1.465,0,0,0,.187.082.65.65,0,1,0,.033,0,.743.743,0,0,0,.31-.166c.031.008.062.018.1.024.058.12.152.279.23.3a1.431,1.431,0,0,0,.185.008.966.966,0,0,1,.144.5.975.975,0,0,1-1.753.593,1.451,1.451,0,0,0-1.3,0,.979.979,0,1,1,0-1.182,1.47,1.47,0,0,0,1.3,0,1,1,0,0,1,.36-.291.145.145,0,0,0,.025.038,1.714,1.714,0,0,0,.184.1m-2.648.078a.669.669,0,1,0,.67.667.668.668,0,0,0-.67-.667"
          transform="translate(-140.774 -43.552)"
          fill="#505152"
        />
        <path
          id="Path_21061"
          data-name="Path 21061"
          d="M169.488,100.507a.669.669,0,1,1-.688-.664l0,0a.135.135,0,0,0,.029,0,.666.666,0,0,1,.656.665"
          transform="translate(-138.16 -43.797)"
          fill="#707173"
        />
        <path
          id="Path_21062"
          data-name="Path 21062"
          d="M173.9,101.176a.669.669,0,1,1,.67-.671.669.669,0,0,1-.67.671"
          transform="translate(-146.098 -43.794)"
          fill="#707173"
        />
        <path
          id="Path_21063"
          data-name="Path 21063"
          d="M158.584,99.421a.145.145,0,0,0,.037-.058.97.97,0,0,1,1.155.311,3.627,3.627,0,0,0,.653.153,3.677,3.677,0,0,0,.652-.153.978.978,0,1,1,0,1.182,3.552,3.552,0,0,0-.652-.155,3.5,3.5,0,0,0-.653.155.975.975,0,1,1-1.43-1.313l.054-.025a1.738,1.738,0,0,0,.184-.1m3.272,1.513a.669.669,0,1,0-.669-.671.669.669,0,0,0,.669.671m-2.854,0a.669.669,0,1,0-.67-.671.67.67,0,0,0,.67.671"
          transform="translate(-125.82 -43.552)"
          fill="#505152"
        />
        <path
          id="Path_21064"
          data-name="Path 21064"
          d="M159.241,99.837a.669.669,0,1,1-.669.667.668.668,0,0,1,.669-.667"
          transform="translate(-123.205 -43.794)"
          fill="#707173"
        />
        <path
          id="Path_21065"
          data-name="Path 21065"
          d="M164.327,99.837a.669.669,0,1,1-.67.667.669.669,0,0,1,.67-.667"
          transform="translate(-131.145 -43.794)"
          fill="#707173"
        />
        <path
          id="Path_21066"
          data-name="Path 21066"
          d="M152.08,99.433c.031.008.062.018.1.024a1.417,1.417,0,0,0,.08.143.667.667,0,1,0,.69.663.658.658,0,0,0-.243-.5.946.946,0,0,0,.119-.007c.052-.011.108-.084.158-.165a.976.976,0,1,1-1.478,1.268,1.451,1.451,0,0,0-1.3,0,.979.979,0,1,1,0-1.182,1.47,1.47,0,0,0,1.3,0,1.072,1.072,0,0,1,.118-.124.848.848,0,0,0,.122.051c.079.019.232-.086.339-.168m-2.659.163a.669.669,0,1,0,.67.667.668.668,0,0,0-.67-.667"
          transform="translate(-110.863 -43.552)"
          fill="#505152"
        />
        <path
          id="Path_21067"
          data-name="Path 21067"
          d="M150.332,100.508a.669.669,0,1,1-.69-.663c.048.076.1.142.15.153a1.617,1.617,0,0,0,.208.008h.089a.658.658,0,0,1,.242.5"
          transform="translate(-108.251 -43.797)"
          fill="#707173"
        />
        <path
          id="Path_21068"
          data-name="Path 21068"
          d="M154.747,101.176a.669.669,0,1,1,.67-.671.669.669,0,0,1-.67.671"
          transform="translate(-116.189 -43.794)"
          fill="#707173"
        />
        <path
          id="Path_21069"
          data-name="Path 21069"
          d="M139.845,99.286a.973.973,0,0,1,.775.388,1.471,1.471,0,0,0,1.305,0,.978.978,0,1,1,0,1.182,1.452,1.452,0,0,0-1.305,0,.977.977,0,1,1-.775-1.57m2.854,1.648a.669.669,0,1,0-.669-.671.669.669,0,0,0,.669.671m-2.854,0a.669.669,0,1,0-.669-.671.67.67,0,0,0,.669.671"
          transform="translate(-95.911 -43.552)"
          fill="#505152"
        />
        <path
          id="Path_21070"
          data-name="Path 21070"
          d="M140.084,99.837a.669.669,0,1,1-.669.667.668.668,0,0,1,.669-.667"
          transform="translate(-93.295 -43.794)"
          fill="#707173"
        />
        <path
          id="Path_21071"
          data-name="Path 21071"
          d="M145.17,99.837a.669.669,0,1,1-.669.667.669.669,0,0,1,.669-.667"
          transform="translate(-101.236 -43.794)"
          fill="#707173"
        />
        <path
          id="Path_21072"
          data-name="Path 21072"
          d="M132.717,99.744a.655.655,0,0,0-.266.519.669.669,0,1,0,1.339,0,.658.658,0,0,0-.511-.635,1.509,1.509,0,0,0,.1-.171c.031-.006.064-.016.094-.024.106.083.26.187.339.168l.019-.007a.975.975,0,1,1-1.484,1.262,1.451,1.451,0,0,0-1.3,0,.979.979,0,1,1,0-1.182,1.47,1.47,0,0,0,1.3,0,.986.986,0,0,1,.176-.176.559.559,0,0,0,.195.246m-2.451-.149a.669.669,0,1,0,.67.667.669.669,0,0,0-.67-.667"
          transform="translate(-80.955 -43.552)"
          fill="#505152"
        />
        <path
          id="Path_21073"
          data-name="Path 21073"
          d="M131.177,100.529a.669.669,0,1,1-1.339,0,.655.655,0,0,1,.266-.519.091.091,0,0,0,.014.008,1.6,1.6,0,0,0,.208.008,1.724,1.724,0,0,0,.208-.008.281.281,0,0,0,.133-.126.659.659,0,0,1,.511.636"
          transform="translate(-78.342 -43.818)"
          fill="#707173"
        />
        <path
          id="Path_21074"
          data-name="Path 21074"
          d="M135.591,101.176a.669.669,0,1,1,.67-.671.67.67,0,0,1-.67.671"
          transform="translate(-86.28 -43.794)"
          fill="#707173"
        />
        <path
          id="Path_21075"
          data-name="Path 21075"
          d="M120.688,99.286a.974.974,0,0,1,.775.388,1.47,1.47,0,0,0,1.3,0,.978.978,0,1,1,0,1.182,1.451,1.451,0,0,0-1.3,0,.977.977,0,1,1-.775-1.57m2.855,1.648a.669.669,0,1,0-.67-.671.669.669,0,0,0,.67.671m-2.855,0a.669.669,0,1,0-.669-.671.67.67,0,0,0,.669.671"
          transform="translate(-66 -43.552)"
          fill="#505152"
        />
        <path
          id="Path_21076"
          data-name="Path 21076"
          d="M120.931,99.837a.669.669,0,1,1-.67.667.668.668,0,0,1,.67-.667"
          transform="translate(-63.389 -43.794)"
          fill="#707173"
        />
        <path
          id="Path_21077"
          data-name="Path 21077"
          d="M126.013,99.837a.669.669,0,1,1-.669.667.669.669,0,0,1,.669-.667"
          transform="translate(-71.326 -43.794)"
          fill="#707173"
        />
        <path
          id="Path_21078"
          data-name="Path 21078"
          d="M113.262,99.76a1.715,1.715,0,0,0,.207-.008c.079-.017.172-.176.232-.3.031-.006.063-.016.094-.024.106.083.261.187.34.168a1.443,1.443,0,0,0,.191-.084c.058-.028.119-.059.155-.081a.976.976,0,1,1-1.291,1.419,1.449,1.449,0,0,0-1.3,0,.979.979,0,1,1,0-1.182,3.605,3.605,0,0,0,.652.153,3.829,3.829,0,0,0,.47-.1.135.135,0,0,0,.046.028,1.519,1.519,0,0,0,.208.008m.7,1.174a.669.669,0,1,0-.67-.671.67.67,0,0,0,.67.671M111.11,99.6a.669.669,0,1,0,.67.667.669.669,0,0,0-.67-.667"
          transform="translate(-51.046 -43.552)"
          fill="#505152"
        />
        <path
          id="Path_21079"
          data-name="Path 21079"
          d="M111.35,99.837a.669.669,0,1,1-.67.667.669.669,0,0,1,.67-.667"
          transform="translate(-48.431 -43.794)"
          fill="#707173"
        />
        <path
          id="Path_21080"
          data-name="Path 21080"
          d="M116.434,101.176a.669.669,0,1,1,.67-.671.67.67,0,0,1-.67.671"
          transform="translate(-56.37 -43.794)"
          fill="#707173"
        />
        <path
          id="Path_21081"
          data-name="Path 21081"
          d="M101.531,99.286a.974.974,0,0,1,.775.388,1.47,1.47,0,0,0,1.3,0,.978.978,0,1,1,0,1.182,1.451,1.451,0,0,0-1.3,0,.977.977,0,1,1-.775-1.57m2.854,1.648a.669.669,0,1,0-.669-.671.67.67,0,0,0,.669.671m-2.854,0a.669.669,0,1,0-.669-.671.67.67,0,0,0,.669.671"
          transform="translate(-36.09 -43.552)"
          fill="#505152"
        />
        <path
          id="Path_21082"
          data-name="Path 21082"
          d="M101.771,99.837a.669.669,0,1,1-.669.667.669.669,0,0,1,.669-.667"
          transform="translate(-33.475 -43.794)"
          fill="#707173"
        />
        <path
          id="Path_21083"
          data-name="Path 21083"
          d="M106.856,99.837a.669.669,0,1,1-.669.667.669.669,0,0,1,.669-.667"
          transform="translate(-41.415 -43.794)"
          fill="#707173"
        />
        <path
          id="Path_21084"
          data-name="Path 21084"
          d="M91.953,99.286a.973.973,0,0,1,.775.388,3.633,3.633,0,0,0,.652.153,3.644,3.644,0,0,0,.652-.153.978.978,0,1,1,0,1.182,3.52,3.52,0,0,0-.652-.155,3.51,3.51,0,0,0-.652.155.977.977,0,1,1-.775-1.57m2.854,1.648a.669.669,0,1,0-.669-.671.67.67,0,0,0,.669.671m-2.854,0a.669.669,0,1,0-.669-.671.67.67,0,0,0,.669.671"
          transform="translate(-21.135 -43.552)"
          fill="#505152"
        />
        <path
          id="Path_21085"
          data-name="Path 21085"
          d="M92.194,99.837a.669.669,0,1,1-.67.667.669.669,0,0,1,.67-.667"
          transform="translate(-18.522 -43.794)"
          fill="#707173"
        />
        <path
          id="Path_21086"
          data-name="Path 21086"
          d="M97.278,99.837a.669.669,0,1,1-.669.667.669.669,0,0,1,.669-.667"
          transform="translate(-26.461 -43.794)"
          fill="#707173"
        />
        <path
          id="Path_21087"
          data-name="Path 21087"
          d="M82.616,101.176a.669.669,0,1,1,.669-.671.67.67,0,0,1-.669.671"
          transform="translate(-3.566 -43.794)"
          fill="#707173"
        />
        <path
          id="Path_21088"
          data-name="Path 21088"
          d="M87.7,101.176a.669.669,0,1,1,.67-.671.67.67,0,0,1-.67.671"
          transform="translate(-11.506 -43.794)"
          fill="#707173"
        />
        <path
          id="Path_21089"
          data-name="Path 21089"
          d="M206.018,80.513a.971.971,0,0,1-.838-.218,1.448,1.448,0,0,0-1.277.269.985.985,0,0,1-.4.425l.112.053a3.747,3.747,0,0,1,.384.2c.132.108.163.492.167.772.052.042.108.08.159.124.274-.06.652-.116.785-.01a3.591,3.591,0,0,1,.282.33,3.4,3.4,0,0,1,.259.349c.073.153-.065.513-.185.766.031.059.059.121.088.181.271.065.639.18.713.335a3.532,3.532,0,0,1,.112.419,3.84,3.84,0,0,1,.082.425c0,.17-.282.434-.5.61,0,.034.006.067.006.1s0,.066-.006.1c.218.178.5.441.5.612a6.026,6.026,0,0,1-.192.845c-.075.154-.442.268-.713.333-.029.062-.057.122-.088.182.12.254.258.613.185.765a3.6,3.6,0,0,1-.259.349,3.278,3.278,0,0,1-.282.329c-.134.106-.511.051-.785-.008-.052.043-.108.081-.161.123,0,.281-.033.665-.166.771a3.676,3.676,0,0,1-.384.2l-.158.074a.977.977,0,0,1,.309.264,1.471,1.471,0,0,0,1.305,0,.978.978,0,1,1,0,1.182,1.452,1.452,0,0,0-1.305,0,.975.975,0,1,1-1.026-1.533c-.081-.053-.161-.109-.23-.163-.065.016-.13.036-.2.049-.126.251-.319.58-.483.617a3.493,3.493,0,0,1-.434.016,3.28,3.28,0,0,1-.433-.016c-.165-.037-.357-.367-.482-.617-.067-.013-.131-.033-.2-.05-.221.172-.542.389-.707.351a3.451,3.451,0,0,1-.4-.173,3.561,3.561,0,0,1-.384-.2c-.134-.107-.164-.491-.167-.772-.053-.041-.108-.08-.159-.123-.274.059-.652.115-.784.009a3.285,3.285,0,0,1-.283-.329,3.512,3.512,0,0,1-.258-.349c-.074-.152.065-.513.184-.766-.031-.059-.06-.121-.088-.181-.273-.066-.639-.18-.713-.335a3.543,3.543,0,0,1-.113-.417,3.741,3.741,0,0,1-.08-.426c0-.171.281-.434.5-.612,0-.033-.006-.067-.006-.1s0-.067.006-.1c-.218-.176-.5-.44-.5-.61a3.123,3.123,0,0,1,.081-.426,3.258,3.258,0,0,1,.111-.418c.074-.154.44-.269.713-.335.028-.061.057-.122.088-.181-.118-.253-.258-.613-.184-.766a3.436,3.436,0,0,1,.258-.349,3.266,3.266,0,0,1,.283-.33c.132-.106.511-.051.784.01.053-.044.106-.083.159-.123,0-.281.034-.665.167-.773a3.686,3.686,0,0,1,.384-.2,3.537,3.537,0,0,1,.4-.175c.166-.038.486.18.707.35.066-.015.13-.035.2-.049.125-.249.317-.578.482-.617a3.61,3.61,0,0,1,.433-.016c.139,0,.3,0,.39.01a.194.194,0,0,1,.044.006c.1.022.2.141.3.286a3.751,3.751,0,0,1,.187.331c.066.014.131.034.2.049.062-.048.133-.1.205-.148a.975.975,0,1,1,.943-1.663,3.636,3.636,0,0,0,.67.015,3.7,3.7,0,0,0,.607-.285.976.976,0,1,1,1.082,1.375m-.171,11.338a.669.669,0,1,0-.669-.671.669.669,0,0,0,.669.671m-3.523-.671a.669.669,0,1,0,.668-.667.669.669,0,0,0-.668.667m-3.858-5.533a2.933,2.933,0,1,0,2.932-2.932,2.933,2.933,0,0,0-2.932,2.932m5.212-5.64a.67.67,0,1,0-.517.794.67.67,0,0,0,.517-.794m2.792-.589a.669.669,0,1,0-.515.794.668.668,0,0,0,.515-.794"
          transform="translate(-191.319 -34.469)"
          fill="#505152"
        />
        <path
          id="Path_21090"
          data-name="Path 21090"
          d="M197.75,80.452a.67.67,0,1,1,.515-.794.671.671,0,0,1-.515.794"
          transform="translate(-183.113 -34.709)"
          fill="#707173"
        />
        <path
          id="Path_21091"
          data-name="Path 21091"
          d="M202.722,81.5a.67.67,0,1,1,.517-.794.669.669,0,0,1-.517.794"
          transform="translate(-190.878 -35.171)"
          fill="#707173"
        />
        <path
          id="Path_21092"
          data-name="Path 21092"
          d="M190.773,78.761a.975.975,0,0,1-.835-.231,3.461,3.461,0,0,0-.67-.026,3.536,3.536,0,0,0-.61.276.977.977,0,1,1-.227-1.16,1.46,1.46,0,0,0,1.279-.25.977.977,0,1,1,1.063,1.391m-3.119-1.069a.67.67,0,1,0,.785.527.669.669,0,0,0-.785-.527m2.8-.548a.67.67,0,1,0,.784.528.669.669,0,0,0-.784-.528"
          transform="translate(-170.706 -33.699)"
          fill="#505152"
        />
        <path
          id="Path_21093"
          data-name="Path 21093"
          d="M188.152,78.7a.67.67,0,1,1,.528-.786.67.67,0,0,1-.528.786"
          transform="translate(-168.145 -33.94)"
          fill="#707173"
        />
        <path
          id="Path_21094"
          data-name="Path 21094"
          d="M193.142,79.676a.67.67,0,1,1,.528-.788.671.671,0,0,1-.528.788"
          transform="translate(-175.935 -34.368)"
          fill="#707173"
        />
        <path
          id="Path_21095"
          data-name="Path 21095"
          d="M181.124,77.17a.973.973,0,0,1-.815-.295,3.462,3.462,0,0,0-.665-.076,3.573,3.573,0,0,0-.63.229.978.978,0,1,1-.139-1.174,3.585,3.585,0,0,0,.666.076,3.735,3.735,0,0,0,.629-.228.977.977,0,1,1,.953,1.467m-3.027-1.3a.67.67,0,1,0,.743.586.668.668,0,0,0-.743-.586m2.835-.334a.67.67,0,1,0,.742.585.669.669,0,0,0-.742-.585"
          transform="translate(-155.737 -32.995)"
          fill="#505152"
        />
        <path
          id="Path_21096"
          data-name="Path 21096"
          d="M178.494,77.1a.67.67,0,1,1,.586-.744.668.668,0,0,1-.586.744"
          transform="translate(-153.143 -33.236)"
          fill="#707173"
        />
        <path
          id="Path_21097"
          data-name="Path 21097"
          d="M183.541,77.7a.67.67,0,1,1,.587-.745.67.67,0,0,1-.587.745"
          transform="translate(-161.026 -33.498)"
          fill="#707173"
        />
        <path
          id="Path_21098"
          data-name="Path 21098"
          d="M171.521,76.348a.972.972,0,0,1-.807-.317,3.608,3.608,0,0,0-.664-.1,3.563,3.563,0,0,0-.636.212.978.978,0,1,1-.106-1.178,3.586,3.586,0,0,0,.664.095,3.716,3.716,0,0,0,.636-.21.966.966,0,1,1,.912,1.494m-2.991-1.389a.67.67,0,1,0,.727.607.67.67,0,0,0-.727-.607m2.844-.253a.67.67,0,1,0,.726.607.668.668,0,0,0-.726-.607"
          transform="translate(-140.78 -32.634)"
          fill="#505152"
        />
        <path
          id="Path_21099"
          data-name="Path 21099"
          d="M168.889,76.282a.67.67,0,1,1,.607-.728.67.67,0,0,1-.607.728"
          transform="translate(-138.176 -32.875)"
          fill="#707173"
        />
        <path
          id="Path_21100"
          data-name="Path 21100"
          d="M173.952,76.732a.67.67,0,1,1,.607-.727.668.668,0,0,1-.607.727"
          transform="translate(-146.083 -33.073)"
          fill="#707173"
        />
        <path
          id="Path_21101"
          data-name="Path 21101"
          d="M161.96,75.395a.972.972,0,0,1-.813-.3,3.631,3.631,0,0,0-.665-.082,3.67,3.67,0,0,0-.632.226.978.978,0,1,1-.131-1.174,3.573,3.573,0,0,0,.666.08,3.674,3.674,0,0,0,.63-.223.977.977,0,1,1,.944,1.474m-3.019-1.324a.67.67,0,1,0,.74.591.671.671,0,0,0-.74-.591m2.838-.314a.67.67,0,1,0,.74.591.668.668,0,0,0-.74-.591"
          transform="translate(-125.825 -32.216)"
          fill="#505152"
        />
        <path
          id="Path_21102"
          data-name="Path 21102"
          d="M159.33,75.33a.67.67,0,1,1,.592-.74.67.67,0,0,1-.592.74"
          transform="translate(-123.229 -32.458)"
          fill="#707173"
        />
        <path
          id="Path_21103"
          data-name="Path 21103"
          d="M164.384,75.889a.67.67,0,1,1,.592-.741.67.67,0,0,1-.592.741"
          transform="translate(-131.12 -32.703)"
          fill="#707173"
        />
        <path
          id="Path_21104"
          data-name="Path 21104"
          d="M152.34,74.626a.978.978,0,0,1-.8-.339,1.451,1.451,0,0,0-1.3.081.978.978,0,1,1-.074-1.18,1.463,1.463,0,0,0,1.3-.08.976.976,0,1,1,.872,1.518m-2.952-1.469a.67.67,0,1,0,.71.626.67.67,0,0,0-.71-.626m2.85-.176a.67.67,0,1,0,.709.626.669.669,0,0,0-.709-.626"
          transform="translate(-110.869 -31.879)"
          fill="#505152"
        />
        <path
          id="Path_21105"
          data-name="Path 21105"
          d="M149.709,74.558a.67.67,0,1,1,.626-.71.669.669,0,0,1-.626.71"
          transform="translate(-108.258 -32.118)"
          fill="#707173"
        />
        <path
          id="Path_21106"
          data-name="Path 21106"
          d="M154.784,74.873a.67.67,0,1,1,.627-.711.669.669,0,0,1-.627.711"
          transform="translate(-116.182 -32.257)"
          fill="#707173"
        />
        <path
          id="Path_21107"
          data-name="Path 21107"
          d="M142.7,74.785a.972.972,0,0,1-.775-.387,1.465,1.465,0,0,0-1.3,0,.978.978,0,1,1,0-1.181,1.465,1.465,0,0,0,1.3,0,.976.976,0,1,1,.775,1.568m-2.854-1.648a.67.67,0,1,0,.669.669.67.67,0,0,0-.669-.669m2.854,0a.67.67,0,1,0,.669.669.669.669,0,0,0-.669-.669"
          transform="translate(-95.909 -31.947)"
          fill="#505152"
        />
        <path
          id="Path_21108"
          data-name="Path 21108"
          d="M140.084,74.717a.67.67,0,1,1,.669-.671.669.669,0,0,1-.669.671"
          transform="translate(-93.295 -32.188)"
          fill="#707173"
        />
        <path
          id="Path_21109"
          data-name="Path 21109"
          d="M145.17,74.717a.67.67,0,1,1,.669-.671.67.67,0,0,1-.669.671"
          transform="translate(-101.236 -32.188)"
          fill="#707173"
        />
        <path
          id="Path_21110"
          data-name="Path 21110"
          d="M133.047,74.807a.975.975,0,0,1-.744-.445,1.456,1.456,0,0,0-1.3-.1.978.978,0,1,1,.09-1.178,3.545,3.545,0,0,0,.638.2,3.613,3.613,0,0,0,.662-.1.977.977,0,1,1,.655,1.624m-2.723-1.86a.67.67,0,1,0,.617.717.67.67,0,0,0-.617-.717m2.848.217a.67.67,0,1,0,.615.717.669.669,0,0,0-.615-.717"
          transform="translate(-80.959 -31.863)"
          fill="#505152"
        />
        <path
          id="Path_21111"
          data-name="Path 21111"
          d="M130.465,74.908a.67.67,0,1,1,.717-.619.67.67,0,0,1-.717.619"
          transform="translate(-78.354 -32.273)"
          fill="#707173"
        />
        <path
          id="Path_21112"
          data-name="Path 21112"
          d="M135.533,74.522a.67.67,0,1,1,.719-.619.67.67,0,0,1-.719.619"
          transform="translate(-86.269 -32.103)"
          fill="#707173"
        />
        <path
          id="Path_21113"
          data-name="Path 21113"
          d="M123.463,75.7a.976.976,0,0,1-.742-.449,3.54,3.54,0,0,0-.638-.206,3.493,3.493,0,0,0-.662.1.978.978,0,1,1,.095-1.178,1.464,1.464,0,0,0,1.3.1.976.976,0,1,1,.646,1.627m-2.713-1.873a.67.67,0,1,0,.613.72.67.67,0,0,0-.613-.72m2.845.23a.67.67,0,1,0,.613.721.67.67,0,0,0-.613-.721"
          transform="translate(-66.004 -32.25)"
          fill="#505152"
        />
        <path
          id="Path_21114"
          data-name="Path 21114"
          d="M120.885,75.816a.67.67,0,1,1,.72-.615.67.67,0,0,1-.72.615"
          transform="translate(-63.401 -32.671)"
          fill="#707173"
        />
        <path
          id="Path_21115"
          data-name="Path 21115"
          d="M125.95,75.407a.67.67,0,1,1,.721-.615.672.672,0,0,1-.721.615"
          transform="translate(-71.312 -32.491)"
          fill="#707173"
        />
        <path
          id="Path_21116"
          data-name="Path 21116"
          d="M113.843,76.608a.97.97,0,0,1-.722-.478,3.634,3.634,0,0,0-.629-.233,3.57,3.57,0,0,0-.666.074.979.979,0,1,1,.143-1.173,1.461,1.461,0,0,0,1.294.159.976.976,0,1,1,.579,1.651m-2.634-1.983a.67.67,0,1,0,.584.747.67.67,0,0,0-.584-.747m2.834.347a.67.67,0,1,0,.583.745.67.67,0,0,0-.583-.745"
          transform="translate(-51.054 -32.597)"
          fill="#505152"
        />
        <path
          id="Path_21117"
          data-name="Path 21117"
          d="M111.288,76.814a.67.67,0,1,1,.745-.585.67.67,0,0,1-.745.585"
          transform="translate(-48.461 -33.11)"
          fill="#707173"
        />
        <path
          id="Path_21118"
          data-name="Path 21118"
          d="M116.333,76.2a.67.67,0,1,1,.747-.583.669.669,0,0,1-.747.583"
          transform="translate(-56.339 -32.838)"
          fill="#707173"
        />
        <path
          id="Path_21119"
          data-name="Path 21119"
          d="M104.242,77.509a.972.972,0,0,1-.711-.495,3.541,3.541,0,0,0-.623-.246,3.383,3.383,0,0,0-.668.059.979.979,0,1,1,.17-1.17,3.572,3.572,0,0,0,.624.245,3.659,3.659,0,0,0,.667-.058.976.976,0,1,1,.541,1.664m-2.588-2.042a.67.67,0,1,0,.566.758.669.669,0,0,0-.566-.758m2.825.411a.67.67,0,1,0,.566.758.669.669,0,0,0-.566-.758"
          transform="translate(-36.102 -32.965)"
          fill="#505152"
        />
        <path
          id="Path_21120"
          data-name="Path 21120"
          d="M101.7,77.766a.67.67,0,1,1,.758-.568.67.67,0,0,1-.758.568"
          transform="translate(-33.518 -33.528)"
          fill="#707173"
        />
        <path
          id="Path_21121"
          data-name="Path 21121"
          d="M106.733,77.033a.67.67,0,1,1,.759-.568.67.67,0,0,1-.759.568"
          transform="translate(-41.374 -33.206)"
          fill="#707173"
        />
        <path
          id="Path_21122"
          data-name="Path 21122"
          d="M94.688,79.3a.972.972,0,0,1-.723-.478,3.5,3.5,0,0,0-.629-.232,3.41,3.41,0,0,0-.666.074.978.978,0,1,1,.144-1.173,3.675,3.675,0,0,0,.628.231,3.69,3.69,0,0,0,.667-.074.976.976,0,1,1,.579,1.651m-2.634-1.982a.67.67,0,1,0,.584.745.671.671,0,0,0-.584-.745m2.834.346a.67.67,0,1,0,.583.745.67.67,0,0,0-.583-.745"
          transform="translate(-21.144 -33.777)"
          fill="#505152"
        />
        <path
          id="Path_21123"
          data-name="Path 21123"
          d="M92.131,79.5a.67.67,0,1,1,.745-.584.669.669,0,0,1-.745.584"
          transform="translate(-18.55 -34.29)"
          fill="#707173"
        />
        <path
          id="Path_21124"
          data-name="Path 21124"
          d="M97.178,78.886a.67.67,0,1,1,.746-.584.669.669,0,0,1-.746.584"
          transform="translate(-26.431 -34.019)"
          fill="#707173"
        />
        <path
          id="Path_21125"
          data-name="Path 21125"
          d="M83.774,79.477a3.61,3.61,0,0,0-.666.07.978.978,0,1,1,.15-1.172,3.651,3.651,0,0,0,.628.235,3.764,3.764,0,0,0,.666-.069.971.971,0,0,1,1.66.566l-.309.117a.661.661,0,0,0-.573-.663.664.664,0,0,0-.584,1.1l-.3.113c-.015-.021-.033-.039-.045-.062a3.516,3.516,0,0,0-.628-.236M82.5,78.2a.67.67,0,1,0,.579.748A.668.668,0,0,0,82.5,78.2"
          transform="translate(-6.208 -34.165)"
          fill="#505152"
        />
        <path
          id="Path_21126"
          data-name="Path 21126"
          d="M81.993,79.663a.669.669,0,0,1,.749-.578.661.661,0,0,1,.572.663l-1.157.438a.662.662,0,0,1-.164-.523"
          transform="translate(-3.62 -34.689)"
          fill="#707173"
        />
        <path
          id="Path_21127"
          data-name="Path 21127"
          d="M87.593,79.767a.67.67,0,1,1,.75-.579.67.67,0,0,1-.75.579"
          transform="translate(-11.472 -34.406)"
          fill="#707173"
        />
        <path
          id="Path_21128"
          data-name="Path 21128"
          d="M206.642,88.878a2.933,2.933,0,1,1-2.933-2.932,2.932,2.932,0,0,1,2.933,2.932m-4.563,0a1.63,1.63,0,1,0,1.63-1.628,1.63,1.63,0,0,0-1.63,1.628"
          transform="translate(-193.628 -37.701)"
          fill="#707173"
        />
        <path
          id="Path_21129"
          data-name="Path 21129"
          d="M206.358,89.9a1.63,1.63,0,1,1-1.63-1.628,1.63,1.63,0,0,1,1.63,1.628"
          transform="translate(-194.648 -38.72)"
          fill="#505152"
        />
        <path
          id="Path_21130"
          data-name="Path 21130"
          d="M182.895,95.7a1.143,1.143,0,0,0,2.286,0c0-.024-.006-.045-.007-.068h1.2l-.034.03c0,.015,0,.031,0,.047s0,.032,0,.048c.1.085.239.211.239.294a1.761,1.761,0,0,1-.039.2,1.67,1.67,0,0,1-.053.2c-.036.074-.213.129-.342.159-.014.031-.027.06-.042.088.056.122.124.295.088.368a1.494,1.494,0,0,1-.125.168,1.521,1.521,0,0,1-.135.157c-.062.051-.245.024-.376,0l-.077.058a1.269,1.269,0,0,1-.026.254.22.22,0,0,1-.053.116,1.734,1.734,0,0,1-.184.1,1.444,1.444,0,0,1-.191.084c-.068.016-.191-.06-.292-.134l-.047-.035c-.031.008-.063.018-.1.024-.06.12-.152.279-.23.3a1.739,1.739,0,0,1-.208.008,1.489,1.489,0,0,1-.207-.008c-.081-.017-.172-.176-.232-.3-.034-.006-.064-.016-.095-.024a1.462,1.462,0,0,1-.177.12.263.263,0,0,1-.163.048,1.48,1.48,0,0,1-.19-.084,1.626,1.626,0,0,1-.184-.1.233.233,0,0,1-.057-.127,1.306,1.306,0,0,1-.023-.243c-.026-.02-.052-.039-.077-.06-.132.029-.313.056-.377.005a1.939,1.939,0,0,1-.135-.159,1.661,1.661,0,0,1-.123-.166c-.036-.073.032-.246.088-.368a.9.9,0,0,1-.042-.088c-.131-.03-.307-.085-.342-.16a1.75,1.75,0,0,1-.054-.2,1.643,1.643,0,0,1-.039-.2c0-.083.135-.209.239-.294a.465.465,0,0,1,0-.048.423.423,0,0,1,0-.047l-.034-.03h.977c0,.023-.007.045-.007.068"
          transform="translate(-162.865 -41.948)"
          fill="#48494a"
        />
        <path
          id="Path_21131"
          data-name="Path 21131"
          d="M185.347,96.839a1.143,1.143,0,0,1-1.142-1.142c0-.024.006-.045.007-.069h2.272c0,.024.007.045.007.069a1.143,1.143,0,0,1-1.144,1.142"
          transform="translate(-164.175 -41.948)"
          fill="#707173"
        />
        <path
          id="Path_21132"
          data-name="Path 21132"
          d="M164.666,95.7a1.142,1.142,0,0,0,2.285,0c0-.024-.006-.045-.007-.068h1.2l-.034.03c0,.015,0,.031,0,.047s0,.032,0,.048c.1.085.238.211.238.294a1.855,1.855,0,0,1-.038.2,1.546,1.546,0,0,1-.053.2c-.035.074-.212.129-.342.159-.013.031-.026.06-.041.088.057.122.123.295.088.368a1.566,1.566,0,0,1-.125.168,1.6,1.6,0,0,1-.135.157c-.064.051-.246.024-.377,0l-.076.058a.983.983,0,0,1-.043.312.141.141,0,0,1-.037.058,1.735,1.735,0,0,1-.184.1l-.054.026a.96.96,0,0,1-.137.058c-.08.019-.234-.086-.339-.168-.031.008-.063.018-.1.024-.059.12-.151.279-.231.3a1.71,1.71,0,0,1-.208.008h-.024a1.414,1.414,0,0,1-.184-.008c-.079-.017-.172-.176-.231-.3-.033-.006-.064-.016-.1-.024a.744.744,0,0,1-.31.166.138.138,0,0,1-.029,0l0,0a1.465,1.465,0,0,1-.186-.082,1.711,1.711,0,0,1-.184-.1.132.132,0,0,1-.025-.038.82.82,0,0,1-.056-.332c-.025-.02-.052-.039-.077-.06-.132.029-.313.056-.377.005a1.809,1.809,0,0,1-.136-.159,1.53,1.53,0,0,1-.122-.166c-.037-.073.031-.246.086-.368-.014-.029-.028-.057-.04-.088-.131-.03-.307-.085-.342-.16a1.724,1.724,0,0,1-.054-.2,1.7,1.7,0,0,1-.038-.2c0-.083.135-.209.238-.294,0-.016,0-.033,0-.048s0-.031,0-.047l-.034-.03h.978c0,.023-.007.045-.007.068"
          transform="translate(-134.402 -41.948)"
          fill="#48494a"
        />
        <path
          id="Path_21133"
          data-name="Path 21133"
          d="M167.117,96.839a1.143,1.143,0,0,1-1.141-1.142c0-.024.006-.045.007-.069h2.271c0,.024.007.045.007.069a1.143,1.143,0,0,1-1.143,1.142"
          transform="translate(-135.712 -41.948)"
          fill="#707173"
        />
        <path
          id="Path_21134"
          data-name="Path 21134"
          d="M153.579,96.606c-.128-.031-.292-.084-.326-.157a1.554,1.554,0,0,1-.055-.2,1.907,1.907,0,0,1-.038-.2c0-.083.135-.209.239-.294,0-.016,0-.033,0-.048s0-.031,0-.047l-.034-.03h.216Z"
          transform="translate(-113.838 -41.948)"
          fill="#48494a"
        />
        <path
          id="Path_21135"
          data-name="Path 21135"
          d="M150.022,97.969a1.92,1.92,0,0,1-.125.168,1.513,1.513,0,0,1-.135.157c-.063.051-.245.024-.375,0l-.079.058c0,.135-.016.319-.079.37a1.973,1.973,0,0,1-.184.1,1.509,1.509,0,0,1-.192.084c-.079.019-.233-.086-.338-.168-.031.008-.063.018-.095.024-.021.042-.046.087-.073.131-.05.081-.107.154-.158.165a.947.947,0,0,1-.119.007h-.089a1.523,1.523,0,0,1-.208-.008c-.048-.011-.1-.077-.15-.153a1.541,1.541,0,0,1-.08-.143c-.034-.006-.065-.016-.1-.024-.107.083-.26.187-.339.168a.845.845,0,0,1-.122-.051l-.07-.033a1.833,1.833,0,0,1-.184-.1c-.063-.051-.079-.235-.079-.37-.026-.02-.053-.039-.077-.06-.132.029-.313.056-.377.005a1.744,1.744,0,0,1-.135-.159,1.45,1.45,0,0,1-.124-.166.448.448,0,0,1,.051-.282l.906,0h.048l.609,0a1.026,1.026,0,0,0,.622,0l1.8.007a.417.417,0,0,1,.045.267"
          transform="translate(-106.233 -42.851)"
          fill="#48494a"
        />
        <path
          id="Path_21136"
          data-name="Path 21136"
          d="M149.234,97.7l.623,0a1.14,1.14,0,0,1-.308.047,1.123,1.123,0,0,1-.315-.05"
          transform="translate(-107.91 -42.855)"
          fill="#707173"
        />
        <path
          id="Path_21137"
          data-name="Path 21137"
          d="M131.794,98a2.013,2.013,0,0,1-.124.168,1.651,1.651,0,0,1-.136.157c-.063.051-.245.024-.376,0-.025.02-.052.039-.077.058,0,.135-.016.319-.079.37a1.9,1.9,0,0,1-.184.1,1.847,1.847,0,0,1-.173.076l-.019.007c-.079.019-.233-.086-.339-.168-.03.008-.063.018-.094.024a1.512,1.512,0,0,1-.1.171c-.043.064-.09.116-.132.125a1.727,1.727,0,0,1-.208.008,1.509,1.509,0,0,1-.208-.008s-.009-.006-.013-.008a.551.551,0,0,1-.195-.246c-.007-.014-.016-.028-.022-.042-.034-.006-.065-.016-.1-.024-.107.083-.26.187-.34.168a1.446,1.446,0,0,1-.19-.084,1.706,1.706,0,0,1-.184-.1c-.065-.051-.079-.235-.08-.37-.027-.02-.053-.039-.077-.06-.132.029-.312.056-.376.005a1.627,1.627,0,0,1-.136-.159,1.664,1.664,0,0,1-.123-.166.375.375,0,0,1,.035-.241l1.817.007c.026,0,.051.008.076.008s.047-.006.071-.007l2.049.008a.359.359,0,0,1,.031.226"
          transform="translate(-77.771 -42.883)"
          fill="#48494a"
        />
        <path
          id="Path_21138"
          data-name="Path 21138"
          d="M131.427,97.772h.147c-.024,0-.046.007-.071.007s-.051-.006-.076-.008"
          transform="translate(-79.632 -42.889)"
          fill="#707173"
        />
        <path
          id="Path_21139"
          data-name="Path 21139"
          d="M113.564,98.033a2.057,2.057,0,0,1-.125.168,1.5,1.5,0,0,1-.136.157c-.063.051-.245.024-.375,0l-.077.058c0,.135-.016.319-.08.37,0,0-.019.011-.028.016-.036.021-.1.053-.155.08a1.442,1.442,0,0,1-.191.084c-.079.019-.234-.086-.339-.168-.03.008-.063.018-.094.024-.06.12-.152.279-.231.3a1.729,1.729,0,0,1-.208.008,1.511,1.511,0,0,1-.208-.008.132.132,0,0,1-.047-.027.846.846,0,0,1-.184-.268c-.034-.006-.065-.016-.1-.024-.106.083-.259.187-.338.168a1.443,1.443,0,0,1-.19-.084,1.638,1.638,0,0,1-.183-.1c-.065-.051-.079-.235-.08-.37-.027-.02-.053-.039-.077-.06-.133.029-.313.056-.377.005a1.708,1.708,0,0,1-.136-.159,1.792,1.792,0,0,1-.124-.166.315.315,0,0,1,.022-.2l4.041.016a.292.292,0,0,1,.017.185"
          transform="translate(-49.308 -42.915)"
          fill="#48494a"
        />
        <path
          id="Path_21140"
          data-name="Path 21140"
          d="M109.581,86.721l-4.332-.008-.305-.5h27.361v.553l-22.425-.043h-.3Z"
          transform="translate(-65.497 -37.817)"
          fill="#505152"
        />
        <path
          id="Path_21141"
          data-name="Path 21141"
          d="M175.039,91.5h-21.9V86.211h21.374l-.226,5.228h.749l.01-4.727Z"
          transform="translate(-135.296 -37.817)"
          fill="#505152"
        />
        <path
          id="Path_21142"
          data-name="Path 21142"
          d="M85.64,82.834s-.033-1.182.977-1.182h9.859l-1.485.56H87.2c-.926,0-.9,1.048-.9,1.048v.216H89.27a11.283,11.283,0,0,0-1.471.849H86.3v.44H85.64v-1.93Z"
          transform="translate(-18.832 -35.817)"
          fill="#666769"
        />
        <path
          id="Path_21143"
          data-name="Path 21143"
          d="M76.62,83.772v-.011l.491-.218c.005.069.006.12.006.12v.407l-.5-.264v-.034"
          transform="translate(5.592 -36.647)"
          fill="#666769"
        />
        <path
          id="Path_21144"
          data-name="Path 21144"
          d="M91.628,98.613H77.683a.9.9,0,0,1-.912-.733l.959,0a.837.837,0,0,0,.537.17H91.044a.853.853,0,0,0,.437-.115l1.04,0a.883.883,0,0,1-.892.669"
          transform="translate(-9.897 -42.936)"
          fill="#666769"
        />
        <path
          id="Path_21145"
          data-name="Path 21145"
          d="M88.286,83.7s-.03-1.047.9-1.047h7.79l-3.191,1.2h0c-.063.022-.1.037-.1.037l-.022-.163-.114-.818s-1.159.444-2.3,1.009H88.286Z"
          transform="translate(-20.813 -36.255)"
          fill="#505152"
        />
        <path
          id="Path_21146"
          data-name="Path 21146"
          d="M89.506,98.056H79.16a.835.835,0,0,1-.536-.17l13.75.056a.849.849,0,0,1-.436.114Z"
          transform="translate(-10.791 -42.938)"
          fill="#505152"
        />
        <path
          id="Path_21147"
          data-name="Path 21147"
          d="M102.592,86.414a2.962,2.962,0,0,0-.513.442l-.981,0v-.441Z"
          transform="translate(-33.625 -37.907)"
          fill="#505152"
        />
        <path
          id="Path_21148"
          data-name="Path 21148"
          d="M55.455,72.556l1.783,4.491-1.759.7L54.12,74.325l.745-.331-.164-.368.851-.378-1.035-2.33-.852.378-.163-.369-.621.276-.795-2,1.759-.7,1.068,2.69,5.492-2.44.6,1.339Z"
          transform="translate(35.479 -30.05)"
          fill="#d4d4d4"
        />
        <path
          id="Path_21149"
          data-name="Path 21149"
          d="M51.223,68.671c.095.076.312.288.586.566l-1.211.536-.12-.27-.6-1.339-.167-.377,1.408-.628-.047.212s-.276.963.146,1.3"
          transform="translate(46.002 -29.459)"
          fill="#3b3c3d"
        />
        <path
          id="Path_21150"
          data-name="Path 21150"
          d="M66.669,73.813,68.3,73.09l.621-.276.164.368.851-.378,1.035,2.331-.851.377.164.369-.744.331-1.5.668-.164-.369L65.437,77.59l-1.979.879a7.123,7.123,0,0,1,.8,1.749l-1.61-.858v-.406s0-.052-.006-.121l-.491.218v-.1c0-.038,0-.081,0-.132v0c0-.052,0-.108,0-.171h0c0-.166-.012-.363-.025-.574h0c0-.008,0-.016,0-.024-.006-.089-.012-.178-.02-.269L62.09,77.7c-.008-.09-.018-.18-.029-.269l-.005-.044a2.617,2.617,0,0,0-.262-.972l2.817-1.251,2.222-.987Z"
          transform="translate(20.064 -31.937)"
          fill="#3b3c3d"
        />
        <path
          id="Path_21151"
          data-name="Path 21151"
          d="M86.167,91.461l-1.04,0L71.377,91.4l-.959,0-2.635-.011-4.042-.016-6.206-.025-2.049-.008h-.147l-1.817-.007L47.289,91.3l-1.8-.007-.623,0-.609,0h.592l0-5.494,3.072-.441,22.425.043h.665l.981,0a2.935,2.935,0,0,1,.513-.442,11.357,11.357,0,0,1,1.471-.849c1.137-.565,2.3-1.009,2.3-1.009l.114.818-3.65,1.29-.428.193,10.282.021h0L72,85.4s-.074.579.312.638l8.946-.321L66.63,88.966l-16.139.3s.038.545.964.728,15.636-.1,15.636-.1l19.665-4.368,2.427-.087h0l2.267,0,1.741,0,.583-.672h3.877l.681.681,6.074.012.013.154-2.833,1.038-1.668.889.065,2.5,2.536,1.482-13.036-.052-2.788-.011Z"
          transform="translate(-3.544 -36.453)"
          fill="#616263"
        />
        <path
          id="Path_21152"
          data-name="Path 21152"
          d="M149.244,87.111H146.35v5.936l-.905,0h-.02v-.177l0-.978.01-4.785,4.332.008Z"
          transform="translate(-105.683 -38.208)"
          fill="#616263"
        />
        <path
          id="Path_21153"
          data-name="Path 21153"
          d="M72.745,85.689l6.036-1.5-.336-.179.5.264,1.61.857.565.3Z"
          transform="translate(3.767 -36.853)"
          fill="#616263"
        />
        <path
          id="Path_21154"
          data-name="Path 21154"
          d="M77.5,83.949v0Z"
          transform="translate(4.708 -36.823)"
          fill="#616263"
        />
        <path
          id="Path_21155"
          data-name="Path 21155"
          d="M77.56,81.657c.008.091.015.18.02.269-.006-.088-.012-.179-.02-.269"
          transform="translate(4.601 -35.82)"
          fill="#616263"
        />
        <path
          id="Path_21156"
          data-name="Path 21156"
          d="M77.636,81.32c-.008-.09-.018-.18-.029-.269.011.089.02.179.029.269"
          transform="translate(4.519 -35.554)"
          fill="#616263"
        />
        <path
          id="Path_21157"
          data-name="Path 21157"
          d="M89.772,80.1a4.605,4.605,0,0,0-.111-.6s-7.419,2.738-7.419,2.947,2.139-.671,4.152-.922a28.384,28.384,0,0,0,3.44-.752c.013.211.021.408.025.573L82.23,83.586,77.513,83.4l2.994-1.008.113-.156c.335-.125,1.583-.594,3.191-1.2l1.485-.56.594-.225.3-.113,1.156-.438.309-.117,1.363-.518.2-.077c.116-.044.209.015.287.135a2.622,2.622,0,0,1,.262.972"
          transform="translate(-7.652 -34.644)"
          fill="#616263"
        />
        <path
          id="Path_21158"
          data-name="Path 21158"
          d="M77.507,83.508v0"
          transform="translate(4.704 -36.63)"
          fill="#616263"
        />
        <path
          id="Path_21159"
          data-name="Path 21159"
          d="M77.5,83.767v0"
          transform="translate(4.708 -36.737)"
          fill="#616263"
        />
        <path
          id="Path_21160"
          data-name="Path 21160"
          d="M71.4,87.256h0l2.017,0Z"
          transform="translate(12.223 -38.275)"
          fill="#616263"
        />
        <path
          id="Path_21161"
          data-name="Path 21161"
          d="M41.62,89.514l1.668-.889,2.833-1.038.024.271-3.217,2.157-.019,2.243,1.717.726,2.437.092.54.431-3.382-.013-2.536-1.482Z"
          transform="translate(54.753 -38.421)"
          fill="#4b4c4d"
        />
        <path
          id="Path_21162"
          data-name="Path 21162"
          d="M41.362,72.407l-8,6.919.261.55-2.437-.091-1.716-.726.019-2.243,3.217-2.157-.024-.272-.013-.154-.585-6.647c-.412-.44-1.683-1.794-2.465-2.588-.274-.278-.491-.491-.586-.566-.422-.338-.146-1.3-.146-1.3l.047-.212.245-1.1,2.268-1.488-.25-2.835,8.518,1.855ZM31.6,75.4l-.072.048.1.223Zm.23,1.357a1.111,1.111,0,1,0,1.111,1.111,1.111,1.111,0,0,0-1.111-1.111M30.8,62.314a1.111,1.111,0,1,0,1.111,1.111A1.111,1.111,0,0,0,30.8,62.314"
          transform="translate(68.19 -25.221)"
          fill="#ffb800"
        />
        <path
          id="Path_21163"
          data-name="Path 21163"
          d="M2.93,73.72,13.4,66.912,11.054,52.151.328,49.341,0,43.46l1.747.868L4.184,47l7.243,1.694,2.218.217,7.1,23.007,2.1-.236s3.244,3.426,3.8,4.229a.736.736,0,0,1-.334,1.168L15.9,74.924l.346-.433-.384-.075,2.774-2.774L12.488,49.727l4.538,21.31L14.01,74.053l.126.025L11.7,73.6l-7.815.877-.41-.327Z"
          transform="translate(98.886 -19.064)"
          fill="#ffb800"
        />
        <path
          id="Path_21164"
          data-name="Path 21164"
          d="M44.907,94.03a1.111,1.111,0,1,1,1.111-1.111,1.111,1.111,0,0,1-1.111,1.111"
          transform="translate(55.116 -40.272)"
          fill="#4b4c4d"
        />
        <path
          id="Path_21165"
          data-name="Path 21165"
          d="M72.6,46.652a1.111,1.111,0,1,1-1.111,1.111A1.111,1.111,0,0,1,72.6,46.652"
          transform="translate(11.878 -20.465)"
          fill="#4b4c4d"
        />
        <path
          id="Path_21166"
          data-name="Path 21166"
          d="M46.743,68.3a1.111,1.111,0,1,1,1.111-1.111A1.111,1.111,0,0,1,46.743,68.3"
          transform="translate(52.25 -28.986)"
          fill="#4b4c4d"
        />
        <path
          id="Path_21167"
          data-name="Path 21167"
          d="M75.5,84.127l.1-.038h0l-.113.155L72.49,85.254l4.717.185L84.837,83.2c0,.062,0,.119,0,.171v0c0,.051,0,.094,0,.132v.148l.336.179-6.036,1.5,8.37-.254h0l.752.4h0l-2.017,0h0l-4.573-.008h0L71.4,85.447l.428-.193,3.65-1.289Z"
          transform="translate(-2.63 -36.496)"
          fill="#4b4c4d"
        />
        <path
          id="Path_21168"
          data-name="Path 21168"
          d="M81.71,81.936c-2.013.251-4.152,1.132-4.152.922s7.419-2.947,7.419-2.947a4.605,4.605,0,0,1,.111.6c0,.015,0,.029.006.044.011.089.02.179.029.269,0,.024,0,.047.006.071.008.091.015.181.02.269,0,.008,0,.016,0,.024a28.491,28.491,0,0,1-3.44.752"
          transform="translate(-2.968 -35.054)"
          fill="#707173"
        />
        <path
          id="Path_21169"
          data-name="Path 21169"
          d="M37,71.507,26.529,78.315l-.261-.551,8-6.919L32.62,57.789,24.1,55.934h0l-.175-2,10.726,2.81Z"
          transform="translate(75.287 -23.66)"
          fill="#db9e00"
        />
        <path
          id="Path_21170"
          data-name="Path 21170"
          d="M46.2,89.392l.033.271-.1-.223Z"
          transform="translate(53.594 -39.213)"
          fill="#db9e00"
        />
        <path
          id="Path_21171"
          data-name="Path 21171"
          d="M19.14,75.935,14.6,54.625,20.75,76.539l-2.774,2.774-1.727-.338-.125-.025Z"
          transform="translate(96.772 -23.963)"
          fill="#db9e00"
        />
        <path
          id="Path_21172"
          data-name="Path 21172"
          d="M144.888,93.054V87.118h3.717l-3.072.441,0,5.494h-.64Z"
          transform="translate(-104.222 -38.214)"
          fill="#707173"
        />
        <path
          id="Path_21173"
          data-name="Path 21173"
          d="M108.076,87.233h0l2.018,0-2.427.087L88,91.693s-14.712.281-15.636.1-.964-.728-.964-.728l16.14-.3,14.625-3.243-8.946.321c-.386-.059-.312-.638-.312-.638l10.6.02h0Z"
          transform="translate(-24.451 -38.252)"
          fill="#707173"
        />
        <path
          id="Path_21174"
          data-name="Path 21174"
          d="M145.761,1.027c0,.386.109,3.005-.193,3.308-.218.217-1.214.172-1.752.129L145.528.8c.131.035.233.1.233.232"
          transform="translate(-100.793 -0.349)"
          fill="#d4d4d4"
        />
        <path
          id="Path_21175"
          data-name="Path 21175"
          d="M147.556,6.738h0l.162.328c-.17-.014-.28-.026-.28-.026Z"
          transform="translate(-104.763 -2.957)"
          fill="#d4d4d4"
        />
        <path
          id="Path_21176"
          data-name="Path 21176"
          d="M143.894.361,147.733,0l-.208.446-1.712,3.67-.032.069-.037-.075-.162-.328Z"
          transform="translate(-102.788 0)"
          fill="#ffb800"
        />
      </g>
    </svg>
  );
};

export default Bulldozer;
